/*! msal v1.2.1 2021-01-18 */
/* eslint-disable */

!(function (e, t) {
    typeof exports === 'object' && typeof module === 'object'
        ? (module.exports = t())
        : typeof define === 'function' && define.amd
        ? define('Msal', [], t)
        : typeof exports === 'object'
        ? (exports.Msal = t())
        : (e.Msal = t());
})(window, () => {
    return (
        (n = {}),
        (o.m = r =
            [
                function (e, t, r) {
                    /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let n = function (e, t) {
                        return (n =
                            Object.setPrototypeOf ||
                            ({ __proto__: [] } instanceof Array &&
                                function (e, t) {
                                    e.__proto__ = t;
                                }) ||
                            function (e, t) {
                                for (const r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
                            })(e, t);
                    };
                    function o(e) {
                        const t = typeof Symbol === 'function' && Symbol.iterator;
                        const r = t && e[t];
                        let n = 0;
                        if (r) return r.call(e);
                        if (e && typeof e.length === 'number')
                            return {
                                next() {
                                    return (
                                        e && n >= e.length && (e = void 0),
                                        { value: e && e[n++], done: !e }
                                    );
                                },
                            };
                        throw new TypeError(
                            t ? 'Object is not iterable.' : 'Symbol.iterator is not defined.'
                        );
                    }
                    function i(e, t) {
                        let r = typeof Symbol === 'function' && e[Symbol.iterator];
                        if (!r) return e;
                        let n;
                        let o;
                        const i = r.call(e);
                        const a = [];
                        try {
                            for (; (void 0 === t || t-- > 0) && !(n = i.next()).done; )
                                a.push(n.value);
                        } catch (e) {
                            o = { error: e };
                        } finally {
                            try {
                                n && !n.done && (r = i.return) && r.call(i);
                            } finally {
                                if (o) throw o.error;
                            }
                        }
                        return a;
                    }
                    function h(e) {
                        return this instanceof h ? ((this.v = e), this) : new h(e);
                    }
                    (t.__extends = function (e, t) {
                        function r() {
                            this.constructor = e;
                        }
                        n(e, t),
                            (e.prototype =
                                t === null
                                    ? Object.create(t)
                                    : ((r.prototype = t.prototype), new r()));
                    }),
                        (t.__assign = function () {
                            return (
                                (t.__assign =
                                    Object.assign ||
                                    function (e) {
                                        for (var t, r = 1, n = arguments.length; r < n; r++)
                                            for (const o in (t = arguments[r]))
                                                Object.prototype.hasOwnProperty.call(t, o) &&
                                                    (e[o] = t[o]);
                                        return e;
                                    }),
                                t.__assign.apply(this, arguments)
                            );
                        }),
                        (t.__rest = function (e, t) {
                            const r = {};
                            for (var n in e)
                                Object.prototype.hasOwnProperty.call(e, n) &&
                                    t.indexOf(n) < 0 &&
                                    (r[n] = e[n]);
                            if (e != null && typeof Object.getOwnPropertySymbols === 'function')
                                for (
                                    var o = 0, n = Object.getOwnPropertySymbols(e);
                                    o < n.length;
                                    o++
                                )
                                    t.indexOf(n[o]) < 0 &&
                                        Object.prototype.propertyIsEnumerable.call(e, n[o]) &&
                                        (r[n[o]] = e[n[o]]);
                            return r;
                        }),
                        (t.__decorate = function (e, t, r, n) {
                            let o;
                            const i = arguments.length;
                            let a =
                                i < 3
                                    ? t
                                    : n === null
                                    ? (n = Object.getOwnPropertyDescriptor(t, r))
                                    : n;
                            if (
                                typeof Reflect === 'object' &&
                                typeof Reflect.decorate === 'function'
                            )
                                a = Reflect.decorate(e, t, r, n);
                            else
                                for (let s = e.length - 1; s >= 0; s--)
                                    (o = e[s]) &&
                                        (a = (i < 3 ? o(a) : i > 3 ? o(t, r, a) : o(t, r)) || a);
                            return i > 3 && a && Object.defineProperty(t, r, a), a;
                        }),
                        (t.__param = function (r, n) {
                            return function (e, t) {
                                n(e, t, r);
                            };
                        }),
                        (t.__metadata = function (e, t) {
                            if (
                                typeof Reflect === 'object' &&
                                typeof Reflect.metadata === 'function'
                            )
                                return Reflect.metadata(e, t);
                        }),
                        (t.__awaiter = function (e, a, s, c) {
                            return new (s = s || Promise)((r, t) => {
                                function n(e) {
                                    try {
                                        i(c.next(e));
                                    } catch (e) {
                                        t(e);
                                    }
                                }
                                function o(e) {
                                    try {
                                        i(c.throw(e));
                                    } catch (e) {
                                        t(e);
                                    }
                                }
                                function i(e) {
                                    let t;
                                    e.done
                                        ? r(e.value)
                                        : ((t = e.value) instanceof s
                                              ? t
                                              : new s((e) => {
                                                    e(t);
                                                })
                                          ).then(n, o);
                                }
                                i((c = c.apply(e, a || [])).next());
                            });
                        }),
                        (t.__generator = function (r, n) {
                            let o;
                            let i;
                            let a;
                            let s = {
                                label: 0,
                                sent() {
                                    if (1 & a[0]) throw a[1];
                                    return a[1];
                                },
                                trys: [],
                                ops: [],
                            };
                            const e = { next: t(0), throw: t(1), return: t(2) };
                            return (
                                typeof Symbol === 'function' &&
                                    (e[Symbol.iterator] = function () {
                                        return this;
                                    }),
                                e
                            );
                            function t(t) {
                                return function (e) {
                                    return (function (t) {
                                        if (o)
                                            throw new TypeError('Generator is already executing.');
                                        for (; s; )
                                            try {
                                                if (
                                                    ((o = 1),
                                                    i &&
                                                        (a =
                                                            2 & t[0]
                                                                ? i.return
                                                                : t[0]
                                                                ? i.throw ||
                                                                  ((a = i.return) && a.call(i), 0)
                                                                : i.next) &&
                                                        !(a = a.call(i, t[1])).done)
                                                )
                                                    return a;
                                                switch (
                                                    ((i = 0), a && (t = [2 & t[0], a.value]), t[0])
                                                ) {
                                                    case 0:
                                                    case 1:
                                                        a = t;
                                                        break;
                                                    case 4:
                                                        return s.label++, { value: t[1], done: !1 };
                                                    case 5:
                                                        s.label++, (i = t[1]), (t = [0]);
                                                        continue;
                                                    case 7:
                                                        (t = s.ops.pop()), s.trys.pop();
                                                        continue;
                                                    default:
                                                        if (
                                                            !(a =
                                                                (a = s.trys).length > 0 &&
                                                                a[a.length - 1]) &&
                                                            (t[0] === 6 || t[0] === 2)
                                                        ) {
                                                            s = 0;
                                                            continue;
                                                        }
                                                        if (
                                                            t[0] === 3 &&
                                                            (!a || (t[1] > a[0] && t[1] < a[3]))
                                                        ) {
                                                            s.label = t[1];
                                                            break;
                                                        }
                                                        if (t[0] === 6 && s.label < a[1]) {
                                                            (s.label = a[1]), (a = t);
                                                            break;
                                                        }
                                                        if (a && s.label < a[2]) {
                                                            (s.label = a[2]), s.ops.push(t);
                                                            break;
                                                        }
                                                        a[2] && s.ops.pop(), s.trys.pop();
                                                        continue;
                                                }
                                                t = n.call(r, s);
                                            } catch (e) {
                                                (t = [6, e]), (i = 0);
                                            } finally {
                                                o = a = 0;
                                            }
                                        if (5 & t[0]) throw t[1];
                                        return { value: t[0] ? t[1] : void 0, done: !0 };
                                    })([t, e]);
                                };
                            }
                        }),
                        (t.__createBinding = function (e, t, r, n) {
                            void 0 === n && (n = r), (e[n] = t[r]);
                        }),
                        (t.__exportStar = function (e, t) {
                            for (const r in e)
                                r === 'default' || t.hasOwnProperty(r) || (t[r] = e[r]);
                        }),
                        (t.__values = o),
                        (t.__read = i),
                        (t.__spread = function () {
                            for (var e = [], t = 0; t < arguments.length; t++)
                                e = e.concat(i(arguments[t]));
                            return e;
                        }),
                        (t.__spreadArrays = function () {
                            for (var e = 0, t = 0, r = arguments.length; t < r; t++)
                                e += arguments[t].length;
                            for (var n = Array(e), o = 0, t = 0; t < r; t++)
                                for (let i = arguments[t], a = 0, s = i.length; a < s; a++, o++)
                                    n[o] = i[a];
                            return n;
                        }),
                        (t.__await = h),
                        (t.__asyncGenerator = function (e, t, r) {
                            if (!Symbol.asyncIterator)
                                throw new TypeError('Symbol.asyncIterator is not defined.');
                            const o = r.apply(e, t || []);
                            const i = [];
                            const a = {};
                            return (
                                n('next'),
                                n('throw'),
                                n('return'),
                                (a[Symbol.asyncIterator] = function () {
                                    return this;
                                }),
                                a
                            );
                            function n(n) {
                                o[n] &&
                                    (a[n] = function (r) {
                                        return new Promise((e, t) => {
                                            i.push([n, r, e, t]) > 1 || s(n, r);
                                        });
                                    });
                            }
                            function s(e, t) {
                                try {
                                    (r = o[e](t)).value instanceof h
                                        ? Promise.resolve(r.value.v).then(c, u)
                                        : l(i[0][2], r);
                                } catch (e) {
                                    l(i[0][3], e);
                                }
                                let r;
                            }
                            function c(e) {
                                s('next', e);
                            }
                            function u(e) {
                                s('throw', e);
                            }
                            function l(e, t) {
                                e(t), i.shift(), i.length && s(i[0][0], i[0][1]);
                            }
                        }),
                        (t.__asyncDelegator = function (n) {
                            let o;
                            const e = {};
                            return (
                                t('next'),
                                t('throw', (e) => {
                                    throw e;
                                }),
                                t('return'),
                                (e[Symbol.iterator] = function () {
                                    return this;
                                }),
                                e
                            );
                            function t(t, r) {
                                e[t] = n[t]
                                    ? function (e) {
                                          return (o = !o)
                                              ? { value: h(n[t](e)), done: t === 'return' }
                                              : r
                                              ? r(e)
                                              : e;
                                      }
                                    : r;
                            }
                        }),
                        (t.__asyncValues = function (c) {
                            if (!Symbol.asyncIterator)
                                throw new TypeError('Symbol.asyncIterator is not defined.');
                            let e;
                            const t = c[Symbol.asyncIterator];
                            return t
                                ? t.call(c)
                                : ((c = o(c)),
                                  (e = {}),
                                  r('next'),
                                  r('throw'),
                                  r('return'),
                                  (e[Symbol.asyncIterator] = function () {
                                      return this;
                                  }),
                                  e);
                            function r(s) {
                                e[s] =
                                    c[s] &&
                                    function (a) {
                                        return new Promise((e, t) => {
                                            let r;
                                            let n;
                                            let o;
                                            let i;
                                            (a = c[s](a)),
                                                (r = e),
                                                (n = t),
                                                (o = a.done),
                                                (i = a.value),
                                                Promise.resolve(i).then((e) => {
                                                    r({ value: e, done: o });
                                                }, n);
                                        });
                                    };
                            }
                        }),
                        (t.__makeTemplateObject = function (e, t) {
                            return (
                                Object.defineProperty
                                    ? Object.defineProperty(e, 'raw', { value: t })
                                    : (e.raw = t),
                                e
                            );
                        }),
                        (t.__importStar = function (e) {
                            if (e && e.__esModule) return e;
                            const t = {};
                            if (e != null)
                                for (const r in e)
                                    Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                            return (t.default = e), t;
                        }),
                        (t.__importDefault = function (e) {
                            return e && e.__esModule ? e : { default: e };
                        }),
                        (t.__classPrivateFieldGet = function (e, t) {
                            if (!t.has(e))
                                throw new TypeError(
                                    'attempted to get private field on non-instance'
                                );
                            return t.get(e);
                        }),
                        (t.__classPrivateFieldSet = function (e, t, r) {
                            if (!t.has(e))
                                throw new TypeError(
                                    'attempted to set private field on non-instance'
                                );
                            return t.set(e, r), r;
                        });
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n =
                        ((o.isEmpty = function (e) {
                            return void 0 === e || !e || e.length === 0;
                        }),
                        o);
                    function o() {}
                    t.StringUtils = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n =
                        ((s.createNewGuid = function () {
                            const e = window.crypto;
                            if (e && e.getRandomValues) {
                                const t = new Uint8Array(16);
                                return (
                                    e.getRandomValues(t),
                                    (t[6] |= 64),
                                    (t[6] &= 79),
                                    (t[8] |= 128),
                                    (t[8] &= 191),
                                    `${
                                        s.decimalToHex(t[0]) +
                                        s.decimalToHex(t[1]) +
                                        s.decimalToHex(t[2]) +
                                        s.decimalToHex(t[3])
                                    }-${s.decimalToHex(t[4])}${s.decimalToHex(
                                        t[5]
                                    )}-${s.decimalToHex(t[6])}${s.decimalToHex(
                                        t[7]
                                    )}-${s.decimalToHex(t[8])}${s.decimalToHex(
                                        t[9]
                                    )}-${s.decimalToHex(t[10])}${s.decimalToHex(
                                        t[11]
                                    )}${s.decimalToHex(t[12])}${s.decimalToHex(
                                        t[13]
                                    )}${s.decimalToHex(t[14])}${s.decimalToHex(t[15])}`
                                );
                            }
                            for (
                                var r = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx',
                                    n = '0123456789abcdef',
                                    o = 0,
                                    i = '',
                                    a = 0;
                                a < 36;
                                a++
                            )
                                r[a] !== '-' && r[a] !== '4' && (o = (16 * Math.random()) | 0),
                                    r[a] === 'x'
                                        ? (i += n[o])
                                        : r[a] === 'y'
                                        ? ((o &= 3), (i += n[(o |= 8)]))
                                        : (i += r[a]);
                            return i;
                        }),
                        (s.isGuid = function (e) {
                            return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
                                e
                            );
                        }),
                        (s.decimalToHex = function (e) {
                            for (var t = e.toString(16); t.length < 2; ) t = `0${t}`;
                            return t;
                        }),
                        (s.base64Encode = function (e) {
                            return btoa(
                                encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, (e, t) =>
                                    String.fromCharCode(Number(`0x${t}`))
                                )
                            );
                        }),
                        (s.base64Decode = function (e) {
                            let t = e.replace(/-/g, '+').replace(/_/g, '/');
                            switch (t.length % 4) {
                                case 0:
                                    break;
                                case 2:
                                    t += '==';
                                    break;
                                case 3:
                                    t += '=';
                                    break;
                                default:
                                    throw new Error('Invalid base64 string');
                            }
                            return decodeURIComponent(
                                atob(t)
                                    .split('')
                                    .map((e) => `%${`00${e.charCodeAt(0).toString(16)}`.slice(-2)}`)
                                    .join('')
                            );
                        }),
                        (s.deserialize = function (e) {
                            for (
                                var t = /\+/g,
                                    r = /([^&=]+)=([^&]*)/g,
                                    n = function (e) {
                                        return decodeURIComponent(e.replace(t, ' '));
                                    },
                                    o = {},
                                    i = r.exec(e);
                                i;

                            )
                                (o[n(i[1])] = n(i[2])), (i = r.exec(e));
                            return o;
                        }),
                        s);
                    function s() {}
                    t.CryptoUtils = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let n;
                    let o;
                    let i;
                    let a;
                    let s;
                    let c;
                    const u =
                        (Object.defineProperty(l, 'claims', {
                            get() {
                                return 'claims';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'clientId', {
                            get() {
                                return 'clientId';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'adalIdToken', {
                            get() {
                                return 'adal.idtoken';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'cachePrefix', {
                            get() {
                                return 'msal';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'scopes', {
                            get() {
                                return 'scopes';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'no_account', {
                            get() {
                                return 'NO_ACCOUNT';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'consumersUtid', {
                            get() {
                                return '9188040d-6c67-4c5b-b112-36a304b66dad';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'upn', {
                            get() {
                                return 'upn';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'prompt_select_account', {
                            get() {
                                return '&prompt=select_account';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'prompt_none', {
                            get() {
                                return '&prompt=none';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'prompt', {
                            get() {
                                return 'prompt';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'response_mode_fragment', {
                            get() {
                                return '&response_mode=fragment';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'resourceDelimiter', {
                            get() {
                                return '|';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'cacheDelimiter', {
                            get() {
                                return '.';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'popUpWidth', {
                            get() {
                                return this._popUpWidth;
                            },
                            set(e) {
                                this._popUpWidth = e;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'popUpHeight', {
                            get() {
                                return this._popUpHeight;
                            },
                            set(e) {
                                this._popUpHeight = e;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'login', {
                            get() {
                                return 'LOGIN';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'renewToken', {
                            get() {
                                return 'RENEW_TOKEN';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'unknown', {
                            get() {
                                return 'UNKNOWN';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'homeAccountIdentifier', {
                            get() {
                                return 'homeAccountIdentifier';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'common', {
                            get() {
                                return 'common';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'openidScope', {
                            get() {
                                return 'openid';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'profileScope', {
                            get() {
                                return 'profile';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'interactionTypeRedirect', {
                            get() {
                                return 'redirectInteraction';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'interactionTypePopup', {
                            get() {
                                return 'popupInteraction';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(l, 'inProgress', {
                            get() {
                                return 'inProgress';
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (l._popUpWidth = 483),
                        (l._popUpHeight = 600),
                        l);
                    function l() {}
                    (t.Constants = u),
                        ((n = t.ServerHashParamKeys || (t.ServerHashParamKeys = {})).SCOPE =
                            'scope'),
                        (n.ERROR = 'error'),
                        (n.ERROR_DESCRIPTION = 'error_description'),
                        (n.ACCESS_TOKEN = 'access_token'),
                        (n.ID_TOKEN = 'id_token'),
                        (n.EXPIRES_IN = 'expires_in'),
                        (n.SESSION_STATE = 'session_state'),
                        (n.CLIENT_INFO = 'client_info'),
                        ((o = t.TemporaryCacheKeys || (t.TemporaryCacheKeys = {})).AUTHORITY =
                            'authority'),
                        (o.ACQUIRE_TOKEN_ACCOUNT = 'acquireTokenAccount'),
                        (o.SESSION_STATE = 'session.state'),
                        (o.STATE_LOGIN = 'state.login'),
                        (o.STATE_ACQ_TOKEN = 'state.acquireToken'),
                        (o.STATE_RENEW = 'state.renew'),
                        (o.NONCE_IDTOKEN = 'nonce.idtoken'),
                        (o.LOGIN_REQUEST = 'login.request'),
                        (o.RENEW_STATUS = 'token.renew.status'),
                        (o.URL_HASH = 'urlHash'),
                        (o.ANGULAR_LOGIN_REQUEST = 'angular.login.request'),
                        (o.INTERACTION_STATUS = 'interaction_status'),
                        (o.REDIRECT_REQUEST = 'redirect_request'),
                        ((i = t.PersistentCacheKeys || (t.PersistentCacheKeys = {})).IDTOKEN =
                            'idtoken'),
                        (i.CLIENT_INFO = 'client.info'),
                        (i.CLIENT_ROUTE = 'client.route'),
                        ((a = t.ErrorCacheKeys || (t.ErrorCacheKeys = {})).LOGIN_ERROR =
                            'login.error'),
                        (a.ERROR = 'error'),
                        (a.ERROR_DESC = 'error.description'),
                        (t.AADTrustedHostList = {
                            'login.windows.net': 'login.windows.net',
                            'login.chinacloudapi.cn': 'login.chinacloudapi.cn',
                            'login.cloudgovapi.us': 'login.cloudgovapi.us',
                            'login.microsoftonline.com': 'login.microsoftonline.com',
                            'login.microsoftonline.de': 'login.microsoftonline.de',
                            'login.microsoftonline.us': 'login.microsoftonline.us',
                        }),
                        ((c = s = t.SSOTypes || (t.SSOTypes = {})).ACCOUNT = 'account'),
                        (c.SID = 'sid'),
                        (c.LOGIN_HINT = 'login_hint'),
                        (c.ID_TOKEN = 'id_token'),
                        (c.DOMAIN_HINT = 'domain_hint'),
                        (c.ORGANIZATIONS = 'organizations'),
                        (c.CONSUMERS = 'consumers'),
                        (c.ACCOUNT_ID = 'accountIdentifier'),
                        (c.HOMEACCOUNT_ID = 'homeAccountIdentifier'),
                        (c.LOGIN_REQ = 'login_req'),
                        (c.DOMAIN_REQ = 'domain_req'),
                        (t.BlacklistedEQParams = [s.SID, s.LOGIN_HINT]),
                        (t.PromptState = {
                            LOGIN: 'login',
                            SELECT_ACCOUNT: 'select_account',
                            CONSENT: 'consent',
                            NONE: 'none',
                        }),
                        (t.libraryVersion = function () {
                            return '1.2.1';
                        });
                },
                function (e, i, t) {
                    Object.defineProperty(i, '__esModule', { value: !0 });
                    const r = t(0);
                    const n = t(6);
                    i.ClientConfigurationErrorMessage = {
                        configurationNotSet: {
                            code: 'no_config_set',
                            desc: 'Configuration has not been set. Please call the UserAgentApplication constructor with a valid Configuration object.',
                        },
                        storageNotSupported: {
                            code: 'storage_not_supported',
                            desc: 'The value for the cacheLocation is not supported.',
                        },
                        noRedirectCallbacksSet: {
                            code: 'no_redirect_callbacks',
                            desc: 'No redirect callbacks have been set. Please call handleRedirectCallback() with the appropriate function arguments before continuing. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics.',
                        },
                        invalidCallbackObject: {
                            code: 'invalid_callback_object',
                            desc: 'The object passed for the callback was invalid. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics.',
                        },
                        scopesRequired: {
                            code: 'scopes_required',
                            desc: 'Scopes are required to obtain an access token.',
                        },
                        emptyScopes: {
                            code: 'empty_input_scopes_error',
                            desc: 'Scopes cannot be passed as empty array.',
                        },
                        nonArrayScopes: {
                            code: 'nonarray_input_scopes_error',
                            desc: 'Scopes cannot be passed as non-array.',
                        },
                        clientScope: {
                            code: 'clientid_input_scopes_error',
                            desc: 'Client ID can only be provided as a single scope.',
                        },
                        invalidPrompt: {
                            code: 'invalid_prompt_value',
                            desc: "Supported prompt values are 'login', 'select_account', 'consent' and 'none'",
                        },
                        invalidAuthorityType: {
                            code: 'invalid_authority_type',
                            desc: 'The given authority is not a valid type of authority supported by MSAL. Please see here for valid authorities: <insert URL here>.',
                        },
                        authorityUriInsecure: {
                            code: 'authority_uri_insecure',
                            desc: 'Authority URIs must use https.',
                        },
                        authorityUriInvalidPath: {
                            code: 'authority_uri_invalid_path',
                            desc: 'Given authority URI is invalid.',
                        },
                        unsupportedAuthorityValidation: {
                            code: 'unsupported_authority_validation',
                            desc: 'The authority validation is not supported for this authority type.',
                        },
                        b2cAuthorityUriInvalidPath: {
                            code: 'b2c_authority_uri_invalid_path',
                            desc: 'The given URI for the B2C authority is invalid.',
                        },
                        claimsRequestParsingError: {
                            code: 'claims_request_parsing_error',
                            desc: 'Could not parse the given claims request object.',
                        },
                        emptyRequestError: {
                            code: 'empty_request_error',
                            desc: 'Request object is required.',
                        },
                        invalidCorrelationIdError: {
                            code: 'invalid_guid_sent_as_correlationId',
                            desc: 'Please set the correlationId as a valid guid',
                        },
                        telemetryConfigError: {
                            code: 'telemetry_config_error',
                            desc: 'Telemetry config is not configured with required values',
                        },
                    };
                    let o;
                    const a =
                        ((o = n.ClientAuthError),
                        r.__extends(s, o),
                        (s.createNoSetConfigurationError = function () {
                            return new s(
                                i.ClientConfigurationErrorMessage.configurationNotSet.code,
                                `${i.ClientConfigurationErrorMessage.configurationNotSet.desc}`
                            );
                        }),
                        (s.createStorageNotSupportedError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.storageNotSupported.code,
                                `${i.ClientConfigurationErrorMessage.storageNotSupported.desc} Given location: ${e}`
                            );
                        }),
                        (s.createRedirectCallbacksNotSetError = function () {
                            return new s(
                                i.ClientConfigurationErrorMessage.noRedirectCallbacksSet.code,
                                i.ClientConfigurationErrorMessage.noRedirectCallbacksSet.desc
                            );
                        }),
                        (s.createInvalidCallbackObjectError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.invalidCallbackObject.code,
                                `${i.ClientConfigurationErrorMessage.invalidCallbackObject.desc} Given value for callback function: ${e}`
                            );
                        }),
                        (s.createEmptyScopesArrayError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.emptyScopes.code,
                                `${i.ClientConfigurationErrorMessage.emptyScopes.desc} Given value: ${e}.`
                            );
                        }),
                        (s.createScopesNonArrayError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.nonArrayScopes.code,
                                `${i.ClientConfigurationErrorMessage.nonArrayScopes.desc} Given value: ${e}.`
                            );
                        }),
                        (s.createClientIdSingleScopeError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.clientScope.code,
                                `${i.ClientConfigurationErrorMessage.clientScope.desc} Given value: ${e}.`
                            );
                        }),
                        (s.createScopesRequiredError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.scopesRequired.code,
                                `${i.ClientConfigurationErrorMessage.scopesRequired.desc} Given value: ${e}`
                            );
                        }),
                        (s.createInvalidPromptError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.invalidPrompt.code,
                                `${i.ClientConfigurationErrorMessage.invalidPrompt.desc} Given value: ${e}`
                            );
                        }),
                        (s.createClaimsRequestParsingError = function (e) {
                            return new s(
                                i.ClientConfigurationErrorMessage.claimsRequestParsingError.code,
                                `${i.ClientConfigurationErrorMessage.claimsRequestParsingError.desc} Given value: ${e}`
                            );
                        }),
                        (s.createEmptyRequestError = function () {
                            const e = i.ClientConfigurationErrorMessage.emptyRequestError;
                            return new s(e.code, e.desc);
                        }),
                        (s.createInvalidCorrelationIdError = function () {
                            return new s(
                                i.ClientConfigurationErrorMessage.invalidCorrelationIdError.code,
                                i.ClientConfigurationErrorMessage.invalidCorrelationIdError.desc
                            );
                        }),
                        (s.createTelemetryConfigError = function (r) {
                            const e = i.ClientConfigurationErrorMessage.telemetryConfigError;
                            const t = e.code;
                            const n = e.desc;
                            const o = {
                                applicationName: 'string',
                                applicationVersion: 'string',
                                telemetryEmitter: 'function',
                            };
                            return new s(
                                t,
                                `${n} mising values: ${Object.keys(o)
                                    .reduce((e, t) => (r[t] ? e : e.concat([`${t} (${o[t]})`])), [])
                                    .join(',')}`
                            );
                        }),
                        s);
                    function s(e, t) {
                        const r = o.call(this, e, t) || this;
                        return (
                            (r.name = 'ClientConfigurationError'),
                            Object.setPrototypeOf(r, s.prototype),
                            r
                        );
                    }
                    i.ClientConfigurationError = a;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const o = r(3);
                    const n = r(10);
                    const i = r(1);
                    const a = r(2);
                    const s =
                        ((c.createNavigateUrl = function (e) {
                            const t = this.createNavigationUrlString(e);
                            let r = e.authorityInstance.AuthorizationEndpoint;
                            return (
                                r.indexOf('?') < 0 ? (r += '?') : (r += '&'), `${r}${t.join('&')}`
                            );
                        }),
                        (c.createNavigationUrlString = function (e) {
                            const t = e.scopes;
                            t.indexOf(e.clientId) === -1 && t.push(e.clientId);
                            const r = [];
                            return (
                                r.push(`response_type=${e.responseType}`),
                                this.translateclientIdUsedInScope(t, e.clientId),
                                r.push(`scope=${encodeURIComponent(n.ScopeSet.parseScope(t))}`),
                                r.push(`client_id=${encodeURIComponent(e.clientId)}`),
                                r.push(`redirect_uri=${encodeURIComponent(e.redirectUri)}`),
                                r.push(`state=${encodeURIComponent(e.state)}`),
                                r.push(`nonce=${encodeURIComponent(e.nonce)}`),
                                r.push('client_info=1'),
                                r.push(`x-client-SKU=${e.xClientSku}`),
                                r.push(`x-client-Ver=${e.xClientVer}`),
                                e.promptValue &&
                                    r.push(`prompt=${encodeURIComponent(e.promptValue)}`),
                                e.claimsValue &&
                                    r.push(`claims=${encodeURIComponent(e.claimsValue)}`),
                                e.queryParameters && r.push(e.queryParameters),
                                e.extraQueryParameters && r.push(e.extraQueryParameters),
                                r.push(`client-request-id=${encodeURIComponent(e.correlationId)}`),
                                r
                            );
                        }),
                        (c.translateclientIdUsedInScope = function (e, t) {
                            const r = e.indexOf(t);
                            r >= 0 &&
                                (e.splice(r, 1),
                                e.indexOf('openid') === -1 && e.push('openid'),
                                e.indexOf('profile') === -1 && e.push('profile'));
                        }),
                        (c.getDefaultRedirectUri = function () {
                            return window.location.href.split('?')[0].split('#')[0];
                        }),
                        (c.replaceTenantPath = function (e, t) {
                            e = e.toLowerCase();
                            const r = this.GetUrlComponents(e);
                            const n = r.PathSegments;
                            return (
                                !t ||
                                    n.length === 0 ||
                                    (n[0] !== o.Constants.common &&
                                        n[0] !== o.SSOTypes.ORGANIZATIONS) ||
                                    (n[0] = t),
                                this.constructAuthorityUriFromObject(r, n)
                            );
                        }),
                        (c.constructAuthorityUriFromObject = function (e, t) {
                            return this.CanonicalizeUri(
                                `${e.Protocol}//${e.HostNameAndPort}/${t.join('/')}`
                            );
                        }),
                        (c.GetUrlComponents = function (e) {
                            if (!e) throw 'Url required';
                            const t = RegExp(
                                '^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?'
                            );
                            const r = e.match(t);
                            if (!r || r.length < 6) throw 'Valid url required';
                            const n = {
                                Protocol: r[1],
                                HostNameAndPort: r[4],
                                AbsolutePath: r[5],
                            };
                            var o = (o = n.AbsolutePath.split('/')).filter(
                                (e) => e && e.length > 0
                            );
                            return (n.PathSegments = o), n;
                        }),
                        (c.CanonicalizeUri = function (e) {
                            return (
                                (e = e && e.toLowerCase()) && !c.endsWith(e, '/') && (e += '/'), e
                            );
                        }),
                        (c.endsWith = function (e, t) {
                            return !(!e || !t) && e.indexOf(t, e.length - t.length) !== -1;
                        }),
                        (c.urlRemoveQueryStringParameter = function (e, t) {
                            if (i.StringUtils.isEmpty(e)) return e;
                            let r = new RegExp(`(\\&${t}=)[^&]+`);
                            return (
                                (e = e.replace(r, '')),
                                (r = new RegExp(`(${t}=)[^&]+&`)),
                                (e = e.replace(r, '')),
                                (r = new RegExp(`(${t}=)[^&]+`)),
                                (e = e.replace(r, ''))
                            );
                        }),
                        (c.getHashFromUrl = function (e) {
                            const t = e.indexOf('#');
                            const r = e.indexOf('#/');
                            return r > -1 ? e.substring(r + 2) : t > -1 ? e.substring(t + 1) : e;
                        }),
                        (c.urlContainsHash = function (e) {
                            const t = c.deserializeHash(e);
                            return (
                                t.hasOwnProperty(o.ServerHashParamKeys.ERROR_DESCRIPTION) ||
                                t.hasOwnProperty(o.ServerHashParamKeys.ERROR) ||
                                t.hasOwnProperty(o.ServerHashParamKeys.ACCESS_TOKEN) ||
                                t.hasOwnProperty(o.ServerHashParamKeys.ID_TOKEN)
                            );
                        }),
                        (c.deserializeHash = function (e) {
                            const t = c.getHashFromUrl(e);
                            return a.CryptoUtils.deserialize(t);
                        }),
                        (c.getHostFromUri = function (e) {
                            return String(e)
                                .replace(/^(https?:)\/\//, '')
                                .split('/')[0];
                        }),
                        c);
                    function c() {}
                    t.UrlUtils = s;
                },
                function (e, r, t) {
                    Object.defineProperty(r, '__esModule', { value: !0 });
                    const n = t(0);
                    const o = t(7);
                    const i = t(1);
                    r.ClientAuthErrorMessage = {
                        multipleMatchingTokens: {
                            code: 'multiple_matching_tokens',
                            desc: 'The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements like authority.',
                        },
                        multipleCacheAuthorities: {
                            code: 'multiple_authorities',
                            desc: 'Multiple authorities found in the cache. Pass authority in the API overload.',
                        },
                        endpointResolutionError: {
                            code: 'endpoints_resolution_error',
                            desc: 'Error: could not resolve endpoints. Please check network and try again.',
                        },
                        popUpWindowError: {
                            code: 'popup_window_error',
                            desc: 'Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser.',
                        },
                        tokenRenewalError: {
                            code: 'token_renewal_error',
                            desc: 'Token renewal operation failed due to timeout.',
                        },
                        invalidIdToken: {
                            code: 'invalid_id_token',
                            desc: 'Invalid ID token format.',
                        },
                        invalidStateError: { code: 'invalid_state_error', desc: 'Invalid state.' },
                        nonceMismatchError: {
                            code: 'nonce_mismatch_error',
                            desc: 'Nonce is not matching, Nonce received: ',
                        },
                        loginProgressError: {
                            code: 'login_progress_error',
                            desc: 'Login_In_Progress: Error during login call - login is already in progress.',
                        },
                        acquireTokenProgressError: {
                            code: 'acquiretoken_progress_error',
                            desc: 'AcquireToken_In_Progress: Error during login call - login is already in progress.',
                        },
                        userCancelledError: {
                            code: 'user_cancelled',
                            desc: 'User cancelled the flow.',
                        },
                        callbackError: {
                            code: 'callback_error',
                            desc: 'Error occurred in token received callback function.',
                        },
                        userLoginRequiredError: {
                            code: 'user_login_error',
                            desc: 'User login is required.',
                        },
                        userDoesNotExistError: {
                            code: 'user_non_existent',
                            desc: 'User object does not exist. Please call a login API.',
                        },
                        clientInfoDecodingError: {
                            code: 'client_info_decoding_error',
                            desc: 'The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause.',
                        },
                        clientInfoNotPopulatedError: {
                            code: 'client_info_not_populated_error',
                            desc: 'The service did not populate client_info in the response, Please verify with the service team',
                        },
                        nullOrEmptyIdToken: {
                            code: 'null_or_empty_id_token',
                            desc: 'The idToken is null or empty. Please review the trace to determine the root cause.',
                        },
                        idTokenNotParsed: {
                            code: 'id_token_parsing_error',
                            desc: 'ID token cannot be parsed. Please review stack trace to determine root cause.',
                        },
                        tokenEncodingError: {
                            code: 'token_encoding_error',
                            desc: 'The token to be decoded is not encoded correctly.',
                        },
                        invalidInteractionType: {
                            code: 'invalid_interaction_type',
                            desc: 'The interaction type passed to the handler was incorrect or unknown',
                        },
                        cacheParseError: {
                            code: 'cannot_parse_cache',
                            desc: 'The cached token key is not a valid JSON and cannot be parsed',
                        },
                        blockTokenRequestsInHiddenIframe: {
                            code: 'block_token_requests',
                            desc: 'Token calls are blocked in hidden iframes',
                        },
                    };
                    let a;
                    const s =
                        ((a = o.AuthError),
                        n.__extends(c, a),
                        (c.createEndpointResolutionError = function (e) {
                            let t = r.ClientAuthErrorMessage.endpointResolutionError.desc;
                            return (
                                e && !i.StringUtils.isEmpty(e) && (t += ` Details: ${e}`),
                                new c(r.ClientAuthErrorMessage.endpointResolutionError.code, t)
                            );
                        }),
                        (c.createMultipleMatchingTokensInCacheError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.multipleMatchingTokens.code,
                                `Cache error for scope ${e}: ${r.ClientAuthErrorMessage.multipleMatchingTokens.desc}.`
                            );
                        }),
                        (c.createMultipleAuthoritiesInCacheError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.multipleCacheAuthorities.code,
                                `Cache error for scope ${e}: ${r.ClientAuthErrorMessage.multipleCacheAuthorities.desc}.`
                            );
                        }),
                        (c.createPopupWindowError = function (e) {
                            let t = r.ClientAuthErrorMessage.popUpWindowError.desc;
                            return (
                                e && !i.StringUtils.isEmpty(e) && (t += ` Details: ${e}`),
                                new c(r.ClientAuthErrorMessage.popUpWindowError.code, t)
                            );
                        }),
                        (c.createTokenRenewalTimeoutError = function (e) {
                            const t = `URL navigated to is ${e}, ${r.ClientAuthErrorMessage.tokenRenewalError.desc}`;
                            return new c(r.ClientAuthErrorMessage.tokenRenewalError.code, t);
                        }),
                        (c.createInvalidIdTokenError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.invalidIdToken.code,
                                `${r.ClientAuthErrorMessage.invalidIdToken.desc} Given token: ${e}`
                            );
                        }),
                        (c.createInvalidStateError = function (e, t) {
                            return new c(
                                r.ClientAuthErrorMessage.invalidStateError.code,
                                `${r.ClientAuthErrorMessage.invalidStateError.desc} ${e}, state expected : ${t}.`
                            );
                        }),
                        (c.createNonceMismatchError = function (e, t) {
                            return new c(
                                r.ClientAuthErrorMessage.nonceMismatchError.code,
                                `${r.ClientAuthErrorMessage.nonceMismatchError.desc} ${e}, nonce expected : ${t}.`
                            );
                        }),
                        (c.createLoginInProgressError = function () {
                            return new c(
                                r.ClientAuthErrorMessage.loginProgressError.code,
                                r.ClientAuthErrorMessage.loginProgressError.desc
                            );
                        }),
                        (c.createAcquireTokenInProgressError = function () {
                            return new c(
                                r.ClientAuthErrorMessage.acquireTokenProgressError.code,
                                r.ClientAuthErrorMessage.acquireTokenProgressError.desc
                            );
                        }),
                        (c.createUserCancelledError = function () {
                            return new c(
                                r.ClientAuthErrorMessage.userCancelledError.code,
                                r.ClientAuthErrorMessage.userCancelledError.desc
                            );
                        }),
                        (c.createErrorInCallbackFunction = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.callbackError.code,
                                `${r.ClientAuthErrorMessage.callbackError.desc} ${e}.`
                            );
                        }),
                        (c.createUserLoginRequiredError = function () {
                            return new c(
                                r.ClientAuthErrorMessage.userLoginRequiredError.code,
                                r.ClientAuthErrorMessage.userLoginRequiredError.desc
                            );
                        }),
                        (c.createUserDoesNotExistError = function () {
                            return new c(
                                r.ClientAuthErrorMessage.userDoesNotExistError.code,
                                r.ClientAuthErrorMessage.userDoesNotExistError.desc
                            );
                        }),
                        (c.createClientInfoDecodingError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.clientInfoDecodingError.code,
                                `${r.ClientAuthErrorMessage.clientInfoDecodingError.desc} Failed with error: ${e}`
                            );
                        }),
                        (c.createClientInfoNotPopulatedError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.clientInfoNotPopulatedError.code,
                                `${r.ClientAuthErrorMessage.clientInfoNotPopulatedError.desc} Failed with error: ${e}`
                            );
                        }),
                        (c.createIdTokenNullOrEmptyError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.nullOrEmptyIdToken.code,
                                `${r.ClientAuthErrorMessage.nullOrEmptyIdToken.desc} Raw ID Token Value: ${e}`
                            );
                        }),
                        (c.createIdTokenParsingError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.idTokenNotParsed.code,
                                `${r.ClientAuthErrorMessage.idTokenNotParsed.desc} Failed with error: ${e}`
                            );
                        }),
                        (c.createTokenEncodingError = function (e) {
                            return new c(
                                r.ClientAuthErrorMessage.tokenEncodingError.code,
                                `${r.ClientAuthErrorMessage.tokenEncodingError.desc} Attempted to decode: ${e}`
                            );
                        }),
                        (c.createInvalidInteractionTypeError = function () {
                            return new c(
                                r.ClientAuthErrorMessage.invalidInteractionType.code,
                                r.ClientAuthErrorMessage.invalidInteractionType.desc
                            );
                        }),
                        (c.createCacheParseError = function (e) {
                            const t = `invalid key: ${e}, ${r.ClientAuthErrorMessage.cacheParseError.desc}`;
                            return new c(r.ClientAuthErrorMessage.cacheParseError.code, t);
                        }),
                        (c.createBlockTokenRequestsInHiddenIframeError = function () {
                            return new c(
                                r.ClientAuthErrorMessage.blockTokenRequestsInHiddenIframe.code,
                                r.ClientAuthErrorMessage.blockTokenRequestsInHiddenIframe.desc
                            );
                        }),
                        c);
                    function c(e, t) {
                        const r = a.call(this, e, t) || this;
                        return (
                            (r.name = 'ClientAuthError'), Object.setPrototypeOf(r, c.prototype), r
                        );
                    }
                    r.ClientAuthError = s;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(0);
                    t.AuthErrorMessage = {
                        unexpectedError: {
                            code: 'unexpected_error',
                            desc: 'Unexpected error in authentication.',
                        },
                        noWindowObjectError: {
                            code: 'no_window_object',
                            desc: 'No window object available. Details:',
                        },
                    };
                    let o;
                    const i =
                        ((o = Error),
                        n.__extends(a, o),
                        (a.createUnexpectedError = function (e) {
                            return new a(
                                t.AuthErrorMessage.unexpectedError.code,
                                `${t.AuthErrorMessage.unexpectedError.desc}: ${e}`
                            );
                        }),
                        (a.createNoWindowObjectError = function (e) {
                            return new a(
                                t.AuthErrorMessage.noWindowObjectError.code,
                                `${t.AuthErrorMessage.noWindowObjectError.desc} ${e}`
                            );
                        }),
                        a);
                    function a(e, t) {
                        const r = o.call(this, t) || this;
                        return (
                            Object.setPrototypeOf(r, a.prototype),
                            (r.errorCode = e),
                            (r.errorMessage = t),
                            (r.name = 'AuthError'),
                            r
                        );
                    }
                    t.AuthError = i;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let n;
                    const o = r(0);
                    const i = r(4);
                    const a = r(17);
                    const s = r(5);
                    ((n = t.AuthorityType || (t.AuthorityType = {}))[(n.Aad = 0)] = 'Aad'),
                        (n[(n.Adfs = 1)] = 'Adfs'),
                        (n[(n.B2C = 2)] = 'B2C');
                    const c =
                        (Object.defineProperty(u.prototype, 'Tenant', {
                            get() {
                                return this.CanonicalAuthorityUrlComponents.PathSegments[0];
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(u.prototype, 'AuthorizationEndpoint', {
                            get() {
                                return (
                                    this.validateResolved(),
                                    this.tenantDiscoveryResponse.AuthorizationEndpoint.replace(
                                        '{tenant}',
                                        this.Tenant
                                    )
                                );
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(u.prototype, 'EndSessionEndpoint', {
                            get() {
                                return (
                                    this.validateResolved(),
                                    this.tenantDiscoveryResponse.EndSessionEndpoint.replace(
                                        '{tenant}',
                                        this.Tenant
                                    )
                                );
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(u.prototype, 'SelfSignedJwtAudience', {
                            get() {
                                return (
                                    this.validateResolved(),
                                    this.tenantDiscoveryResponse.Issuer.replace(
                                        '{tenant}',
                                        this.Tenant
                                    )
                                );
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (u.prototype.validateResolved = function () {
                            if (!this.tenantDiscoveryResponse)
                                throw 'Please call ResolveEndpointsAsync first';
                        }),
                        Object.defineProperty(u.prototype, 'CanonicalAuthority', {
                            get() {
                                return this.canonicalAuthority;
                            },
                            set(e) {
                                (this.canonicalAuthority = s.UrlUtils.CanonicalizeUri(e)),
                                    (this.canonicalAuthorityUrlComponents = null);
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(u.prototype, 'CanonicalAuthorityUrlComponents', {
                            get() {
                                return (
                                    this.canonicalAuthorityUrlComponents ||
                                        (this.canonicalAuthorityUrlComponents =
                                            s.UrlUtils.GetUrlComponents(this.CanonicalAuthority)),
                                    this.canonicalAuthorityUrlComponents
                                );
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(u.prototype, 'DefaultOpenIdConfigurationEndpoint', {
                            get() {
                                return `${this.CanonicalAuthority}v2.0/.well-known/openid-configuration`;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (u.prototype.validateAsUri = function () {
                            let e;
                            try {
                                e = this.CanonicalAuthorityUrlComponents;
                            } catch (e) {
                                throw i.ClientConfigurationErrorMessage.invalidAuthorityType;
                            }
                            if (!e.Protocol || e.Protocol.toLowerCase() !== 'https:')
                                throw i.ClientConfigurationErrorMessage.authorityUriInsecure;
                            if (!e.PathSegments || e.PathSegments.length < 1)
                                throw i.ClientConfigurationErrorMessage.authorityUriInvalidPath;
                        }),
                        (u.prototype.DiscoverEndpoints = function (e) {
                            return new a.XhrClient().sendRequestAsync(e, 'GET', !0).then((e) => ({
                                AuthorizationEndpoint: e.authorization_endpoint,
                                EndSessionEndpoint: e.end_session_endpoint,
                                Issuer: e.issuer,
                            }));
                        }),
                        (u.prototype.resolveEndpointsAsync = function () {
                            return o.__awaiter(this, void 0, Promise, function () {
                                let t;
                                let r;
                                return o.__generator(this, function (e) {
                                    switch (e.label) {
                                        case 0:
                                            return [4, this.GetOpenIdConfigurationEndpointAsync()];
                                        case 1:
                                            return (
                                                (t = e.sent()), [4, (r = this).DiscoverEndpoints(t)]
                                            );
                                        case 2:
                                            return (
                                                (r.tenantDiscoveryResponse = e.sent()), [2, this]
                                            );
                                    }
                                });
                            });
                        }),
                        u);
                    function u(e, t) {
                        (this.IsValidationEnabled = t),
                            (this.CanonicalAuthority = e),
                            this.validateAsUri();
                    }
                    t.Authority = c;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 }),
                        (t.EVENT_NAME_PREFIX = 'msal.'),
                        (t.EVENT_NAME_KEY = 'event_name'),
                        (t.START_TIME_KEY = 'start_time'),
                        (t.ELAPSED_TIME_KEY = 'elapsed_time'),
                        (t.TELEMETRY_BLOB_EVENT_NAMES = {
                            MsalCorrelationIdConstStrKey: 'Microsoft.MSAL.correlation_id',
                            ApiTelemIdConstStrKey: 'msal.api_telem_id',
                            ApiIdConstStrKey: 'msal.api_id',
                            BrokerAppConstStrKey: 'Microsoft_MSAL_broker_app',
                            CacheEventCountConstStrKey: 'Microsoft_MSAL_cache_event_count',
                            HttpEventCountTelemetryBatchKey: 'Microsoft_MSAL_http_event_count',
                            IdpConstStrKey: 'Microsoft_MSAL_idp',
                            IsSilentTelemetryBatchKey: '',
                            IsSuccessfulConstStrKey: 'Microsoft_MSAL_is_successful',
                            ResponseTimeConstStrKey: 'Microsoft_MSAL_response_time',
                            TenantIdConstStrKey: 'Microsoft_MSAL_tenant_id',
                            UiEventCountTelemetryBatchKey: 'Microsoft_MSAL_ui_event_count',
                        }),
                        (t.TENANT_PLACEHOLDER = '<tenant>');
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(4);
                    const o =
                        ((i.isIntersectingScopes = function (e, t) {
                            e = this.convertToLowerCase(e);
                            for (let r = 0; r < t.length; r++)
                                if (e.indexOf(t[r].toLowerCase()) > -1) return !0;
                            return !1;
                        }),
                        (i.containsScope = function (t, e) {
                            return (
                                (t = this.convertToLowerCase(t)),
                                e.every((e) => t.indexOf(e.toString().toLowerCase()) >= 0)
                            );
                        }),
                        (i.convertToLowerCase = function (e) {
                            return e.map((e) => e.toLowerCase());
                        }),
                        (i.removeElement = function (e, t) {
                            return e.filter((e) => e !== t);
                        }),
                        (i.parseScope = function (e) {
                            let t = '';
                            if (e)
                                for (let r = 0; r < e.length; ++r)
                                    t += r !== e.length - 1 ? `${e[r]} ` : e[r];
                            return t;
                        }),
                        (i.validateInputScope = function (e, t, r) {
                            if (e) {
                                if (!Array.isArray(e))
                                    throw n.ClientConfigurationError.createScopesNonArrayError(e);
                                if (e.length < 1)
                                    throw n.ClientConfigurationError.createEmptyScopesArrayError(
                                        e.toString()
                                    );
                                if (e.indexOf(r) > -1 && e.length > 1)
                                    throw n.ClientConfigurationError.createClientIdSingleScopeError(
                                        e.toString()
                                    );
                            } else if (t)
                                throw n.ClientConfigurationError.createScopesRequiredError(e);
                        }),
                        (i.getScopeFromState = function (e) {
                            if (e) {
                                const t = e.indexOf('|');
                                if (t > -1 && t + 1 < e.length) return e.substring(t + 1);
                            }
                            return '';
                        }),
                        (i.appendScopes = function (e, t) {
                            return e ? (t ? e.concat(t) : e) : null;
                        }),
                        i);
                    function i() {}
                    t.ScopeSet = o;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let c;
                    let n;
                    const i = r(1);
                    const a = r(3);
                    ((n = c = t.LogLevel || (t.LogLevel = {}))[(n.Error = 0)] = 'Error'),
                        (n[(n.Warning = 1)] = 'Warning'),
                        (n[(n.Info = 2)] = 'Info'),
                        (n[(n.Verbose = 3)] = 'Verbose');
                    const o =
                        ((s.prototype.logMessage = function (e, t, r) {
                            let n;
                            let o;
                            e > this.level ||
                                (!this.piiLoggingEnabled && r) ||
                                ((n = new Date().toUTCString()),
                                (o = i.StringUtils.isEmpty(this.correlationId)
                                    ? `${n}:${a.libraryVersion()}-${c[e]} ${t}`
                                    : `${n}:${this.correlationId}-${a.libraryVersion()}-${
                                          c[e]
                                      } ${t}`),
                                this.executeCallback(e, o, r));
                        }),
                        (s.prototype.executeCallback = function (e, t, r) {
                            this.localCallback && this.localCallback(e, t, r);
                        }),
                        (s.prototype.error = function (e) {
                            this.logMessage(c.Error, e, !1);
                        }),
                        (s.prototype.errorPii = function (e) {
                            this.logMessage(c.Error, e, !0);
                        }),
                        (s.prototype.warning = function (e) {
                            this.logMessage(c.Warning, e, !1);
                        }),
                        (s.prototype.warningPii = function (e) {
                            this.logMessage(c.Warning, e, !0);
                        }),
                        (s.prototype.info = function (e) {
                            this.logMessage(c.Info, e, !1);
                        }),
                        (s.prototype.infoPii = function (e) {
                            this.logMessage(c.Info, e, !0);
                        }),
                        (s.prototype.verbose = function (e) {
                            this.logMessage(c.Verbose, e, !1);
                        }),
                        (s.prototype.verbosePii = function (e) {
                            this.logMessage(c.Verbose, e, !0);
                        }),
                        (s.prototype.isPiiLoggingEnabled = function () {
                            return this.piiLoggingEnabled;
                        }),
                        s);
                    function s(e, t) {
                        void 0 === t && (t = {}), (this.level = c.Info);
                        const r = t.correlationId;
                        const n = void 0 === r ? '' : r;
                        const o = t.level;
                        const i = void 0 === o ? c.Info : o;
                        const a = t.piiLoggingEnabled;
                        const s = void 0 !== a && a;
                        (this.localCallback = e),
                            (this.correlationId = n),
                            (this.level = i),
                            (this.piiLoggingEnabled = s);
                    }
                    t.Logger = o;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(0);
                    const o = r(7);
                    t.ServerErrorMessage = {
                        serverUnavailable: {
                            code: 'server_unavailable',
                            desc: 'Server is temporarily unavailable.',
                        },
                        unknownServerError: { code: 'unknown_server_error' },
                    };
                    let i;
                    const a =
                        ((i = o.AuthError),
                        n.__extends(s, i),
                        (s.createServerUnavailableError = function () {
                            return new s(
                                t.ServerErrorMessage.serverUnavailable.code,
                                t.ServerErrorMessage.serverUnavailable.desc
                            );
                        }),
                        (s.createUnknownServerError = function (e) {
                            return new s(t.ServerErrorMessage.unknownServerError.code, e);
                        }),
                        s);
                    function s(e, t) {
                        const r = i.call(this, e, t) || this;
                        return (r.name = 'ServerError'), Object.setPrototypeOf(r, s.prototype), r;
                    }
                    t.ServerError = a;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const m = r(0);
                    const E = r(25);
                    const C = r(26);
                    const y = r(27);
                    const v = r(28);
                    const I = r(29);
                    const T = r(30);
                    const S = r(15);
                    const _ = r(10);
                    const A = r(1);
                    const w = r(33);
                    const f = r(14);
                    const O = r(34);
                    const b = r(5);
                    const o = r(35);
                    const R = r(36);
                    const P = r(37);
                    const n = r(19);
                    const a = r(4);
                    const k = r(7);
                    const N = r(6);
                    const U = r(12);
                    const M = r(20);
                    const x = r(21);
                    const s = m.__importDefault(r(38));
                    const K = r(3);
                    const L = 'id_token';
                    const i = 'token';
                    const c = 'id_token token';
                    const u =
                        (Object.defineProperty(l.prototype, 'authority', {
                            get() {
                                return this.authorityInstance.CanonicalAuthority;
                            },
                            set(e) {
                                this.authorityInstance = P.AuthorityFactory.CreateInstance(
                                    e,
                                    this.config.auth.validateAuthority
                                );
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (l.prototype.getAuthorityInstance = function () {
                            return this.authorityInstance;
                        }),
                        (l.prototype.handleRedirectCallback = function (e, t) {
                            if (!e)
                                throw (
                                    ((this.redirectCallbacksSet = !1),
                                    a.ClientConfigurationError.createInvalidCallbackObjectError(e))
                                );
                            t
                                ? ((this.tokenReceivedCallback = e),
                                  (this.errorReceivedCallback = t),
                                  this.logger.warning(
                                      'This overload for callback is deprecated - please change the format of the callbacks to a single callback as shown: (err: AuthError, response: AuthResponse).'
                                  ))
                                : (this.authResponseCallback = e),
                                (this.redirectCallbacksSet = !0);
                            const r = this.cacheStorage.getItem(K.TemporaryCacheKeys.URL_HASH);
                            r && this.processCallBack(r, null);
                        }),
                        (l.prototype.urlContainsHash = function (e) {
                            return b.UrlUtils.urlContainsHash(e);
                        }),
                        (l.prototype.authResponseHandler = function (e, t, r) {
                            if (e === K.Constants.interactionTypeRedirect)
                                this.errorReceivedCallback
                                    ? this.tokenReceivedCallback(t)
                                    : this.authResponseCallback &&
                                      this.authResponseCallback(null, t);
                            else {
                                if (e !== K.Constants.interactionTypePopup)
                                    throw N.ClientAuthError.createInvalidInteractionTypeError();
                                r(t);
                            }
                        }),
                        (l.prototype.authErrorHandler = function (e, t, r, n) {
                            if (
                                (this.cacheStorage.removeItem(
                                    K.TemporaryCacheKeys.INTERACTION_STATUS
                                ),
                                e === K.Constants.interactionTypeRedirect)
                            )
                                this.errorReceivedCallback
                                    ? this.errorReceivedCallback(t, r.accountState)
                                    : this.authResponseCallback(t, r);
                            else {
                                if (e !== K.Constants.interactionTypePopup)
                                    throw N.ClientAuthError.createInvalidInteractionTypeError();
                                n(t);
                            }
                        }),
                        (l.prototype.loginRedirect = function (e) {
                            const t = o.RequestUtils.validateRequest(
                                e,
                                !0,
                                this.clientId,
                                K.Constants.interactionTypeRedirect,
                                this.redirectCallbacksSet
                            );
                            this.acquireTokenInteractive(
                                K.Constants.interactionTypeRedirect,
                                !0,
                                t,
                                null,
                                null
                            );
                        }),
                        (l.prototype.acquireTokenRedirect = function (e) {
                            const t = o.RequestUtils.validateRequest(
                                e,
                                !1,
                                this.clientId,
                                K.Constants.interactionTypeRedirect,
                                this.redirectCallbacksSet
                            );
                            this.acquireTokenInteractive(
                                K.Constants.interactionTypeRedirect,
                                !1,
                                t,
                                null,
                                null
                            );
                        }),
                        (l.prototype.loginPopup = function (e) {
                            const r = this;
                            const n = o.RequestUtils.validateRequest(
                                e,
                                !0,
                                this.clientId,
                                K.Constants.interactionTypePopup
                            );
                            return new Promise((e, t) => {
                                r.acquireTokenInteractive(
                                    K.Constants.interactionTypePopup,
                                    !0,
                                    n,
                                    e,
                                    t
                                );
                            }).catch((e) => {
                                throw (r.cacheStorage.resetTempCacheItems(n.state), e);
                            });
                        }),
                        (l.prototype.acquireTokenPopup = function (e) {
                            const r = this;
                            const n = o.RequestUtils.validateRequest(
                                e,
                                !1,
                                this.clientId,
                                K.Constants.interactionTypePopup
                            );
                            return new Promise((e, t) => {
                                r.acquireTokenInteractive(
                                    K.Constants.interactionTypePopup,
                                    !1,
                                    n,
                                    e,
                                    t
                                );
                            }).catch((e) => {
                                throw (r.cacheStorage.resetTempCacheItems(n.state), e);
                            });
                        }),
                        (l.prototype.acquireTokenInteractive = function (t, r, n, o, i) {
                            const a = this;
                            w.WindowUtils.blockReloadInHiddenIframes();
                            const e = this.cacheStorage.getItem(
                                K.TemporaryCacheKeys.INTERACTION_STATUS
                            );
                            if (
                                (t === K.Constants.interactionTypeRedirect &&
                                    this.cacheStorage.setItem(
                                        K.TemporaryCacheKeys.REDIRECT_REQUEST,
                                        `${K.Constants.inProgress}${K.Constants.resourceDelimiter}${n.state}`
                                    ),
                                e === K.Constants.inProgress)
                            ) {
                                const s = r
                                    ? N.ClientAuthError.createLoginInProgressError()
                                    : N.ClientAuthError.createAcquireTokenInProgressError();
                                var c = x.buildResponseStateOnly(this.getAccountState(n.state));
                                return (
                                    this.cacheStorage.resetTempCacheItems(n.state),
                                    void this.authErrorHandler(t, s, c, i)
                                );
                            }
                            let u;
                            const l = n && n.account && !r ? n.account : this.getAccount();
                            if (l || y.ServerRequestParameters.isSSOParam(n))
                                this.acquireTokenHelper(l, t, r, n, o, i);
                            else {
                                if (!r)
                                    return (
                                        this.logger.info('User login is required'),
                                        (c = x.buildResponseStateOnly(
                                            this.getAccountState(n.state)
                                        )),
                                        this.cacheStorage.resetTempCacheItems(n.state),
                                        void this.authErrorHandler(
                                            t,
                                            N.ClientAuthError.createUserLoginRequiredError(),
                                            c,
                                            i
                                        )
                                    );
                                this.extractADALIdToken() && !n.scopes
                                    ? (this.logger.info(
                                          "ADAL's idToken exists. Extracting login information from ADAL's idToken "
                                      ),
                                      (u = this.buildIDTokenRequest(n)),
                                      (this.silentLogin = !0),
                                      this.acquireTokenSilent(u).then(
                                          (e) => {
                                              (a.silentLogin = !1),
                                                  a.logger.info('Unified cache call is successful'),
                                                  a.authResponseHandler(t, e, o);
                                          },
                                          (e) => {
                                              (a.silentLogin = !1),
                                                  a.logger.error(
                                                      `Error occurred during unified cache ATS: ${e}`
                                                  ),
                                                  a.acquireTokenHelper(null, t, r, n, o, i);
                                          }
                                      ))
                                    : this.acquireTokenHelper(null, t, r, n, o, i);
                            }
                        }),
                        (l.prototype.acquireTokenHelper = function (a, s, c, u, l, h) {
                            const t = this;
                            this.cacheStorage.setItem(
                                K.TemporaryCacheKeys.INTERACTION_STATUS,
                                K.Constants.inProgress
                            );
                            let d;
                            let p;
                            const f = u.scopes
                                ? u.scopes.join(' ').toLowerCase()
                                : this.clientId.toLowerCase();
                            const g =
                                u && u.authority
                                    ? P.AuthorityFactory.CreateInstance(
                                          u.authority,
                                          this.config.auth.validateAuthority
                                      )
                                    : this.authorityInstance;
                            if (s === K.Constants.interactionTypePopup) {
                                try {
                                    (p = this.openPopup(
                                        'about:blank',
                                        'msal',
                                        K.Constants.popUpWidth,
                                        K.Constants.popUpHeight
                                    )),
                                        w.WindowUtils.trackPopup(p);
                                } catch (e) {
                                    this.logger.info(
                                        `${N.ClientAuthErrorMessage.popUpWindowError.code}:${N.ClientAuthErrorMessage.popUpWindowError.desc}`
                                    ),
                                        this.cacheStorage.setItem(
                                            K.ErrorCacheKeys.ERROR,
                                            N.ClientAuthErrorMessage.popUpWindowError.code
                                        ),
                                        this.cacheStorage.setItem(
                                            K.ErrorCacheKeys.ERROR_DESC,
                                            N.ClientAuthErrorMessage.popUpWindowError.desc
                                        ),
                                        h && h(N.ClientAuthError.createPopupWindowError());
                                }
                                if (!p) return;
                            }
                            g.resolveEndpointsAsync()
                                .then(() =>
                                    m.__awaiter(t, void 0, void 0, function () {
                                        let t;
                                        let r;
                                        let n;
                                        let o;
                                        let i;
                                        return m.__generator(this, function (e) {
                                            switch (e.label) {
                                                case 0:
                                                    if (
                                                        ((t = c
                                                            ? L
                                                            : this.getTokenType(a, u.scopes, !1)),
                                                        c &&
                                                            ((r = this.cacheStorage.getItem(
                                                                `${K.TemporaryCacheKeys.ANGULAR_LOGIN_REQUEST}${K.Constants.resourceDelimiter}${u.state}`
                                                            )) && r !== ''
                                                                ? this.cacheStorage.setItem(
                                                                      `${K.TemporaryCacheKeys.ANGULAR_LOGIN_REQUEST}${K.Constants.resourceDelimiter}${u.state}`,
                                                                      ''
                                                                  )
                                                                : (r = window.location.href)),
                                                        (d = new y.ServerRequestParameters(
                                                            g,
                                                            this.clientId,
                                                            t,
                                                            this.getRedirectUri(u && u.redirectUri),
                                                            u.scopes,
                                                            u.state,
                                                            u.correlationId
                                                        )),
                                                        this.updateCacheEntries(d, a, r),
                                                        d.populateQueryParams(a, u),
                                                        (n =
                                                            b.UrlUtils.createNavigateUrl(d) +
                                                            K.Constants.response_mode_fragment),
                                                        s === K.Constants.interactionTypeRedirect)
                                                    )
                                                        c ||
                                                            this.cacheStorage.setItem(
                                                                `${K.TemporaryCacheKeys.STATE_ACQ_TOKEN}${K.Constants.resourceDelimiter}${u.state}`,
                                                                d.state,
                                                                this.inCookie
                                                            );
                                                    else {
                                                        if (s !== K.Constants.interactionTypePopup)
                                                            throw N.ClientAuthError.createInvalidInteractionTypeError();
                                                        window.renewStates.push(d.state),
                                                            (window.requestType = c
                                                                ? K.Constants.login
                                                                : K.Constants.renewToken),
                                                            this.registerCallback(d.state, f, l, h);
                                                    }
                                                    if ((this.navigateWindow(n, p), !p))
                                                        return [3, 4];
                                                    e.label = 1;
                                                case 1:
                                                    return (
                                                        e.trys.push([1, 3, , 4]),
                                                        [
                                                            4,
                                                            w.WindowUtils.monitorWindowForHash(
                                                                p,
                                                                this.config.system.loadFrameTimeout,
                                                                n
                                                            ),
                                                        ]
                                                    );
                                                case 2:
                                                    return (
                                                        (o = e.sent()),
                                                        this.handleAuthenticationResponse(o),
                                                        this.cacheStorage.removeItem(
                                                            K.TemporaryCacheKeys.INTERACTION_STATUS
                                                        ),
                                                        this.logger.info('Closing popup window'),
                                                        this.config.framework.isAngular &&
                                                            (this.broadcast(
                                                                'msal:popUpHashChanged',
                                                                o
                                                            ),
                                                            w.WindowUtils.closePopups()),
                                                        [3, 4]
                                                    );
                                                case 3:
                                                    return (
                                                        (i = e.sent()),
                                                        h && h(i),
                                                        this.config.framework.isAngular
                                                            ? this.broadcast(
                                                                  'msal:popUpClosed',
                                                                  i.errorCode +
                                                                      K.Constants
                                                                          .resourceDelimiter +
                                                                      i.errorMessage
                                                              )
                                                            : (this.cacheStorage.removeItem(
                                                                  K.TemporaryCacheKeys
                                                                      .INTERACTION_STATUS
                                                              ),
                                                              p.close()),
                                                        [3, 4]
                                                    );
                                                case 4:
                                                    return [2];
                                            }
                                        });
                                    })
                                )
                                .catch((e) => {
                                    t.logger.warning('could not resolve endpoints'),
                                        t.cacheStorage.resetTempCacheItems(u.state),
                                        t.authErrorHandler(
                                            s,
                                            N.ClientAuthError.createEndpointResolutionError(
                                                e.toString
                                            ),
                                            x.buildResponseStateOnly(u.state),
                                            h
                                        ),
                                        p && p.close();
                                });
                        }),
                        (l.prototype.acquireTokenSilent = function (e) {
                            const d = this;
                            const p = o.RequestUtils.validateRequest(e, !1, this.clientId);
                            return new Promise((e, t) => {
                                w.WindowUtils.blockReloadInHiddenIframes();
                                const r = p.scopes.join(' ').toLowerCase();
                                const n = p.account || d.getAccount();
                                const o = d.cacheStorage.getItem(K.Constants.adalIdToken);
                                if (!n && !p.sid && !p.loginHint && A.StringUtils.isEmpty(o))
                                    return (
                                        d.logger.info('User login is required'),
                                        t(N.ClientAuthError.createUserLoginRequiredError())
                                    );
                                let i;
                                const a = d.getTokenType(n, p.scopes, !0);
                                const s = new y.ServerRequestParameters(
                                    P.AuthorityFactory.CreateInstance(
                                        p.authority,
                                        d.config.auth.validateAuthority
                                    ),
                                    d.clientId,
                                    a,
                                    d.getRedirectUri(p.redirectUri),
                                    p.scopes,
                                    p.state,
                                    p.correlationId
                                );
                                y.ServerRequestParameters.isSSOParam(p) || n
                                    ? s.populateQueryParams(n, p)
                                    : n ||
                                      A.StringUtils.isEmpty(o) ||
                                      ((i = f.TokenUtils.extractIdToken(o)),
                                      d.logger.verbose(
                                          "ADAL's idToken exists. Extracting login information from ADAL's idToken "
                                      ),
                                      s.populateQueryParams(n, null, i));
                                let c;
                                let u;
                                const l = p.claimsRequest || s.claimsValue;
                                if (!l && !p.forceRefresh)
                                    try {
                                        u = d.getCachedToken(s, n);
                                    } catch (e) {
                                        c = e;
                                    }
                                if (u)
                                    return (
                                        d.logger.info(`Token is already in cache for scope:${r}`),
                                        e(u),
                                        null
                                    );
                                if (c)
                                    return (
                                        d.logger.infoPii(`${c.errorCode}:${c.errorMessage}`),
                                        t(c),
                                        null
                                    );
                                var h = void 0;
                                var h = l
                                    ? 'Skipped cache lookup since claims were given.'
                                    : p.forceRefresh
                                    ? 'Skipped cache lookup since request.forceRefresh option was set to true'
                                    : `Token is not in cache for scope:${r}`;
                                return (
                                    d.logger.verbose(h),
                                    s.authorityInstance ||
                                        (s.authorityInstance = p.authority
                                            ? P.AuthorityFactory.CreateInstance(
                                                  p.authority,
                                                  d.config.auth.validateAuthority
                                              )
                                            : d.authorityInstance),
                                    s.authorityInstance
                                        .resolveEndpointsAsync()
                                        .then(() => {
                                            window.activeRenewals[r]
                                                ? (d.logger.verbose(
                                                      `Renew token for scope: ${r} is in progress. Registering callback`
                                                  ),
                                                  d.registerCallback(
                                                      window.activeRenewals[r],
                                                      r,
                                                      e,
                                                      t
                                                  ))
                                                : p.scopes &&
                                                  p.scopes.indexOf(d.clientId) > -1 &&
                                                  p.scopes.length === 1
                                                ? (d.logger.verbose('renewing idToken'),
                                                  (d.silentLogin = !0),
                                                  d.renewIdToken(p.scopes, e, t, n, s))
                                                : (d.logger.verbose('renewing accesstoken'),
                                                  d.renewToken(p.scopes, e, t, n, s));
                                        })
                                        .catch(
                                            (e) => (
                                                d.logger.warning('could not resolve endpoints'),
                                                t(
                                                    N.ClientAuthError.createEndpointResolutionError(
                                                        e.toString()
                                                    )
                                                ),
                                                null
                                            )
                                        )
                                );
                            }).catch((e) => {
                                throw (d.cacheStorage.resetTempCacheItems(p.state), e);
                            });
                        }),
                        (l.prototype.openPopup = function (e, t, r, n) {
                            try {
                                const o = window.screenLeft ? window.screenLeft : window.screenX;
                                const i = window.screenTop ? window.screenTop : window.screenY;
                                const a =
                                    window.innerWidth ||
                                    document.documentElement.clientWidth ||
                                    document.body.clientWidth;
                                const s =
                                    window.innerHeight ||
                                    document.documentElement.clientHeight ||
                                    document.body.clientHeight;
                                const c = a / 2 - r / 2 + o;
                                const u = s / 2 - n / 2 + i;
                                const l = window.open(
                                    e,
                                    t,
                                    `width=${r}, height=${n}, top=${u}, left=${c}`
                                );
                                if (!l) throw N.ClientAuthError.createPopupWindowError();
                                return l.focus && l.focus(), l;
                            } catch (e) {
                                throw (
                                    (this.logger.error(`error opening popup ${e.message}`),
                                    this.cacheStorage.removeItem(
                                        K.TemporaryCacheKeys.INTERACTION_STATUS
                                    ),
                                    N.ClientAuthError.createPopupWindowError(e.toString()))
                                );
                            }
                        }),
                        (l.prototype.loadIframeTimeout = function (i, a, s) {
                            return m.__awaiter(this, void 0, Promise, function () {
                                let t;
                                let r;
                                let n;
                                let o;
                                return m.__generator(this, function (e) {
                                    switch (e.label) {
                                        case 0:
                                            return (
                                                (t = window.activeRenewals[s]),
                                                this.logger.verbose(
                                                    `Set loading state to pending for: ${s}:${t}`
                                                ),
                                                this.cacheStorage.setItem(
                                                    `${K.TemporaryCacheKeys.RENEW_STATUS}${K.Constants.resourceDelimiter}${t}`,
                                                    K.Constants.inProgress
                                                ),
                                                [
                                                    4,
                                                    w.WindowUtils.loadFrame(
                                                        i,
                                                        a,
                                                        this.config.system.navigateFrameWait,
                                                        this.logger
                                                    ),
                                                ]
                                            );
                                        case 1:
                                            (r = e.sent()), (e.label = 2);
                                        case 2:
                                            return (
                                                e.trys.push([2, 4, , 5]),
                                                [
                                                    4,
                                                    w.WindowUtils.monitorWindowForHash(
                                                        r.contentWindow,
                                                        this.config.system.loadFrameTimeout,
                                                        i
                                                    ),
                                                ]
                                            );
                                        case 3:
                                            return (
                                                (n = e.sent()) &&
                                                    this.handleAuthenticationResponse(n),
                                                [3, 5]
                                            );
                                        case 4:
                                            throw (
                                                ((o = e.sent()),
                                                this.cacheStorage.getItem(
                                                    `${K.TemporaryCacheKeys.RENEW_STATUS}${K.Constants.resourceDelimiter}${t}`
                                                ) === K.Constants.inProgress &&
                                                    (this.logger.verbose(
                                                        `Loading frame has timed out after: ${
                                                            this.config.system.loadFrameTimeout /
                                                            1e3
                                                        } seconds for scope ${s}:${t}`
                                                    ),
                                                    t &&
                                                        window.callbackMappedToRenewStates[t] &&
                                                        window.callbackMappedToRenewStates[t](
                                                            null,
                                                            o
                                                        ),
                                                    this.cacheStorage.removeItem(
                                                        `${K.TemporaryCacheKeys.RENEW_STATUS}${K.Constants.resourceDelimiter}${t}`
                                                    )),
                                                w.WindowUtils.removeHiddenIframe(r),
                                                o)
                                            );
                                        case 5:
                                            return w.WindowUtils.removeHiddenIframe(r), [2];
                                    }
                                });
                            });
                        }),
                        (l.prototype.navigateWindow = function (e, t) {
                            if (!e || A.StringUtils.isEmpty(e))
                                throw (
                                    (this.logger.info('Navigate url is empty'),
                                    k.AuthError.createUnexpectedError('Navigate url is empty'))
                                );
                            const r = t || window;
                            const n = t ? `Navigated Popup window to:${e}` : `Navigate to:${e}`;
                            this.logger.infoPii(n), r.location.assign(e);
                        }),
                        (l.prototype.registerCallback = function (n, o, e, t) {
                            const i = this;
                            (window.activeRenewals[o] = n),
                                window.promiseMappedToRenewStates[n] ||
                                    (window.promiseMappedToRenewStates[n] = []),
                                window.promiseMappedToRenewStates[n].push({
                                    resolve: e,
                                    reject: t,
                                }),
                                window.callbackMappedToRenewStates[n] ||
                                    (window.callbackMappedToRenewStates[n] = function (e, t) {
                                        window.activeRenewals[o] = null;
                                        for (
                                            let r = 0;
                                            r < window.promiseMappedToRenewStates[n].length;
                                            ++r
                                        )
                                            try {
                                                if (t)
                                                    window.promiseMappedToRenewStates[n][r].reject(
                                                        t
                                                    );
                                                else {
                                                    if (!e)
                                                        throw (
                                                            (i.cacheStorage.resetTempCacheItems(n),
                                                            k.AuthError.createUnexpectedError(
                                                                'Error and response are both null'
                                                            ))
                                                        );
                                                    window.promiseMappedToRenewStates[n][r].resolve(
                                                        e
                                                    );
                                                }
                                            } catch (e) {
                                                i.logger.warning(e);
                                            }
                                        (window.promiseMappedToRenewStates[n] = null),
                                            (window.callbackMappedToRenewStates[n] = null);
                                    });
                        }),
                        (l.prototype.logout = function () {
                            const r = this;
                            this.clearCache(), (this.account = null);
                            let n = '';
                            this.getPostLogoutRedirectUri() &&
                                (n = `post_logout_redirect_uri=${encodeURIComponent(
                                    this.getPostLogoutRedirectUri()
                                )}`),
                                this.authorityInstance.resolveEndpointsAsync().then((e) => {
                                    const t = e.EndSessionEndpoint
                                        ? `${e.EndSessionEndpoint}?${n}`
                                        : `${r.authority}oauth2/v2.0/logout?${n}`;
                                    r.navigateWindow(t);
                                });
                        }),
                        (l.prototype.clearCache = function () {
                            window.renewStates = [];
                            for (
                                let e = this.cacheStorage.getAllAccessTokens(
                                        K.Constants.clientId,
                                        K.Constants.homeAccountIdentifier
                                    ),
                                    t = 0;
                                t < e.length;
                                t++
                            )
                                this.cacheStorage.removeItem(JSON.stringify(e[t].key));
                            this.cacheStorage.resetCacheItems(),
                                this.cacheStorage.clearMsalCookie();
                        }),
                        (l.prototype.clearCacheForScope = function (e) {
                            for (
                                let t = this.cacheStorage.getAllAccessTokens(
                                        K.Constants.clientId,
                                        K.Constants.homeAccountIdentifier
                                    ),
                                    r = 0;
                                r < t.length;
                                r++
                            ) {
                                const n = t[r];
                                n.value.accessToken === e &&
                                    this.cacheStorage.removeItem(JSON.stringify(n.key));
                            }
                        }),
                        (l.prototype.isCallback = function (e) {
                            return (
                                this.logger.info(
                                    'isCallback will be deprecated in favor of urlContainsHash in MSAL.js v2.0.'
                                ),
                                b.UrlUtils.urlContainsHash(e)
                            );
                        }),
                        (l.prototype.processCallBack = function (e, t, r) {
                            let n;
                            let o;
                            this.logger.info('Processing the callback from redirect response'),
                                (t = t || this.getResponseState(e));
                            try {
                                n = this.saveTokenFromHash(e, t);
                            } catch (e) {
                                o = e;
                            }
                            this.cacheStorage.removeItem(K.TemporaryCacheKeys.URL_HASH);
                            try {
                                this.cacheStorage.clearMsalCookie(t.state);
                                const i = this.getAccountState(t.state);
                                if (n) {
                                    if (
                                        (t.requestType === K.Constants.renewToken || n.accessToken
                                            ? (window.parent !== window
                                                  ? this.logger.verbose(
                                                        'Window is in iframe, acquiring token silently'
                                                    )
                                                  : this.logger.verbose(
                                                        'acquiring token interactive in progress'
                                                    ),
                                              (n.tokenType = K.ServerHashParamKeys.ACCESS_TOKEN))
                                            : t.requestType === K.Constants.login &&
                                              (n.tokenType = K.ServerHashParamKeys.ID_TOKEN),
                                        !r)
                                    )
                                        return void this.authResponseHandler(
                                            K.Constants.interactionTypeRedirect,
                                            n
                                        );
                                } else if (!r)
                                    return (
                                        this.cacheStorage.resetTempCacheItems(t.state),
                                        void this.authErrorHandler(
                                            K.Constants.interactionTypeRedirect,
                                            o,
                                            x.buildResponseStateOnly(i)
                                        )
                                    );
                                r(n, o);
                            } catch (e) {
                                throw (
                                    (this.logger.error(
                                        `Error occurred in token received callback function: ${e}`
                                    ),
                                    N.ClientAuthError.createErrorInCallbackFunction(e.toString()))
                                );
                            }
                        }),
                        (l.prototype.handleAuthenticationResponse = function (e) {
                            const t = e || window.location.hash;
                            const r = w.WindowUtils.getIframeWithHash(t);
                            const n = w.WindowUtils.getPopUpWithHash(t);
                            const o = !(!r && !n);
                            const i = this.getResponseState(t);
                            var a = null;
                            if ((this.logger.info('Returned from redirect url'), o))
                                a = window.callbackMappedToRenewStates[i.state];
                            else {
                                let s;
                                var a = null;
                                if (this.config.auth.navigateToLoginRequestUrl)
                                    return (
                                        this.cacheStorage.setItem(K.TemporaryCacheKeys.URL_HASH, t),
                                        void (
                                            window.parent === window &&
                                            ((s = this.cacheStorage.getItem(
                                                `${K.TemporaryCacheKeys.LOGIN_REQUEST}${K.Constants.resourceDelimiter}${i.state}`,
                                                this.inCookie
                                            )) && s !== 'null'
                                                ? (window.location.href = s)
                                                : (this.logger.error(
                                                      'Unable to get valid login request url from cache, redirecting to home page'
                                                  ),
                                                  (window.location.href = '/')))
                                        )
                                    );
                                if (((window.location.hash = ''), !this.redirectCallbacksSet))
                                    return void this.cacheStorage.setItem(
                                        K.TemporaryCacheKeys.URL_HASH,
                                        t
                                    );
                            }
                            this.processCallBack(t, i, a), o && w.WindowUtils.closePopups();
                        }),
                        (l.prototype.getResponseState = function (e) {
                            let t;
                            const r = b.UrlUtils.deserializeHash(e);
                            if (!r)
                                throw k.AuthError.createUnexpectedError(
                                    'Hash was not parsed correctly.'
                                );
                            if (!r.hasOwnProperty('state'))
                                throw k.AuthError.createUnexpectedError(
                                    'Hash does not contain state.'
                                );
                            if (
                                (t = {
                                    requestType: K.Constants.unknown,
                                    state: r.state,
                                    stateMatch: !1,
                                }).state ===
                                    this.cacheStorage.getItem(
                                        `${K.TemporaryCacheKeys.STATE_LOGIN}${K.Constants.resourceDelimiter}${t.state}`,
                                        this.inCookie
                                    ) ||
                                t.state === this.silentAuthenticationState
                            )
                                return (t.requestType = K.Constants.login), (t.stateMatch = !0), t;
                            if (
                                t.state ===
                                this.cacheStorage.getItem(
                                    `${K.TemporaryCacheKeys.STATE_ACQ_TOKEN}${K.Constants.resourceDelimiter}${t.state}`,
                                    this.inCookie
                                )
                            )
                                return (
                                    (t.requestType = K.Constants.renewToken), (t.stateMatch = !0), t
                                );
                            if (!t.stateMatch) {
                                t.requestType = window.requestType;
                                for (let n = window.renewStates, o = 0; o < n.length; o++)
                                    if (n[o] === t.state) {
                                        t.stateMatch = !0;
                                        break;
                                    }
                            }
                            return t;
                        }),
                        (l.prototype.getCachedToken = function (e, t) {
                            let r = null;
                            const n = e.scopes;
                            const o = this.cacheStorage.getAllAccessTokens(
                                this.clientId,
                                t ? t.homeAccountIdentifier : null
                            );
                            if (o.length === 0) return null;
                            const i = [];
                            if (e.authority) {
                                for (a = 0; a < o.length; a++)
                                    (c = (s = o[a]).key.scopes.split(' ')),
                                        _.ScopeSet.containsScope(c, n) &&
                                            b.UrlUtils.CanonicalizeUri(s.key.authority) ===
                                                e.authority &&
                                            i.push(s);
                                if (i.length === 0) return null;
                                if (i.length !== 1)
                                    throw N.ClientAuthError.createMultipleMatchingTokensInCacheError(
                                        n.toString()
                                    );
                                r = i[0];
                            } else {
                                for (var a = 0; a < o.length; a++) {
                                    var s;
                                    var c = (s = o[a]).key.scopes.split(' ');
                                    _.ScopeSet.containsScope(c, n) && i.push(s);
                                }
                                if (i.length === 1)
                                    (r = i[0]),
                                        (e.authorityInstance = P.AuthorityFactory.CreateInstance(
                                            r.key.authority,
                                            this.config.auth.validateAuthority
                                        ));
                                else {
                                    if (i.length > 1)
                                        throw N.ClientAuthError.createMultipleMatchingTokensInCacheError(
                                            n.toString()
                                        );
                                    const u = this.getUniqueAuthority(o, 'authority');
                                    if (u.length > 1)
                                        throw N.ClientAuthError.createMultipleAuthoritiesInCacheError(
                                            n.toString()
                                        );
                                    e.authorityInstance = P.AuthorityFactory.CreateInstance(
                                        u[0],
                                        this.config.auth.validateAuthority
                                    );
                                }
                            }
                            if (r == null) return null;
                            const l = Number(r.value.expiresIn);
                            const h = this.config.system.tokenRenewalOffsetSeconds || 300;
                            if (l && l > O.TimeUtils.now() + h) {
                                const d = new I.IdToken(r.value.idToken);
                                if (!t && !(t = this.getAccount()))
                                    throw k.AuthError.createUnexpectedError(
                                        'Account should not be null here.'
                                    );
                                const p = this.getAccountState(e.state);
                                const f = {
                                    uniqueId: '',
                                    tenantId: '',
                                    tokenType:
                                        r.value.idToken === r.value.accessToken
                                            ? K.ServerHashParamKeys.ID_TOKEN
                                            : K.ServerHashParamKeys.ACCESS_TOKEN,
                                    idToken: d,
                                    idTokenClaims: d.claims,
                                    accessToken: r.value.accessToken,
                                    scopes: r.key.scopes.split(' '),
                                    expiresOn: new Date(1e3 * l),
                                    account: t,
                                    accountState: p,
                                    fromCache: !0,
                                };
                                return R.ResponseUtils.setResponseIdToken(f, d), f;
                            }
                            return this.cacheStorage.removeItem(JSON.stringify(i[0].key)), null;
                        }),
                        (l.prototype.getUniqueAuthority = function (e, t) {
                            const r = [];
                            const n = [];
                            return (
                                e.forEach((e) => {
                                    e.key.hasOwnProperty(t) &&
                                        n.indexOf(e.key[t]) === -1 &&
                                        (n.push(e.key[t]), r.push(e.key[t]));
                                }),
                                r
                            );
                        }),
                        (l.prototype.extractADALIdToken = function () {
                            const e = this.cacheStorage.getItem(K.Constants.adalIdToken);
                            return A.StringUtils.isEmpty(e) ? null : f.TokenUtils.extractIdToken(e);
                        }),
                        (l.prototype.renewToken = function (e, t, r, n, o) {
                            const i = e.join(' ').toLowerCase();
                            this.logger.verbose(`renewToken is called for scope:${i}`);
                            const a = `msalRenewFrame${i}`;
                            const s = w.WindowUtils.addHiddenIFrame(a, this.logger);
                            this.updateCacheEntries(o, n),
                                this.logger.verbose(`Renew token Expected state: ${o.state}`);
                            const c =
                                b.UrlUtils.urlRemoveQueryStringParameter(
                                    b.UrlUtils.createNavigateUrl(o),
                                    K.Constants.prompt
                                ) +
                                K.Constants.prompt_none +
                                K.Constants.response_mode_fragment;
                            window.renewStates.push(o.state),
                                (window.requestType = K.Constants.renewToken),
                                this.registerCallback(o.state, i, t, r),
                                this.logger.infoPii(`Navigate to:${c}`),
                                (s.src = 'about:blank'),
                                this.loadIframeTimeout(c, a, i).catch((e) => r(e));
                        }),
                        (l.prototype.renewIdToken = function (e, t, r, n, o) {
                            this.logger.info('renewidToken is called');
                            const i = 'msalIdTokenFrame';
                            const a = w.WindowUtils.addHiddenIFrame(i, this.logger);
                            this.updateCacheEntries(o, n),
                                this.logger.verbose(`Renew Idtoken Expected state: ${o.state}`);
                            const s =
                                b.UrlUtils.urlRemoveQueryStringParameter(
                                    b.UrlUtils.createNavigateUrl(o),
                                    K.Constants.prompt
                                ) +
                                K.Constants.prompt_none +
                                K.Constants.response_mode_fragment;
                            this.silentLogin
                                ? ((window.requestType = K.Constants.login),
                                  (this.silentAuthenticationState = o.state))
                                : ((window.requestType = K.Constants.renewToken),
                                  window.renewStates.push(o.state)),
                                this.registerCallback(o.state, this.clientId, t, r),
                                this.logger.infoPii(`Navigate to:${s}`),
                                (a.src = 'about:blank'),
                                this.loadIframeTimeout(s, i, this.clientId).catch((e) => r(e));
                        }),
                        (l.prototype.saveAccessToken = function (e, t, r, n, o) {
                            let i;
                            const a = m.__assign({}, e);
                            const s = new v.ClientInfo(n);
                            if (r.hasOwnProperty(K.ServerHashParamKeys.SCOPE)) {
                                for (
                                    var c = (i = r[K.ServerHashParamKeys.SCOPE]).split(' '),
                                        u = this.cacheStorage.getAllAccessTokens(this.clientId, t),
                                        l = 0;
                                    l < u.length;
                                    l++
                                ) {
                                    var h;
                                    const d = u[l];
                                    d.key.homeAccountIdentifier ===
                                        e.account.homeAccountIdentifier &&
                                        ((h = d.key.scopes.split(' ')),
                                        _.ScopeSet.isIntersectingScopes(h, c) &&
                                            this.cacheStorage.removeItem(JSON.stringify(d.key)));
                                }
                                const p = O.TimeUtils.parseExpiresIn(
                                    r[K.ServerHashParamKeys.EXPIRES_IN]
                                );
                                var f = O.TimeUtils.now() + p;
                                var g = new E.AccessTokenKey(t, this.clientId, i, s.uid, s.utid);
                                var y = new C.AccessTokenValue(
                                    r[K.ServerHashParamKeys.ACCESS_TOKEN],
                                    o.rawIdToken,
                                    f.toString(),
                                    n
                                );
                                this.cacheStorage.setItem(JSON.stringify(g), JSON.stringify(y)),
                                    (a.accessToken = r[K.ServerHashParamKeys.ACCESS_TOKEN]),
                                    (a.scopes = c);
                            } else
                                (i = this.clientId),
                                    (g = new E.AccessTokenKey(t, this.clientId, i, s.uid, s.utid)),
                                    (f = Number(o.expiration)),
                                    (y = new C.AccessTokenValue(
                                        r[K.ServerHashParamKeys.ID_TOKEN],
                                        r[K.ServerHashParamKeys.ID_TOKEN],
                                        f.toString(),
                                        n
                                    )),
                                    this.cacheStorage.setItem(JSON.stringify(g), JSON.stringify(y)),
                                    (a.scopes = [i]),
                                    (a.accessToken = r[K.ServerHashParamKeys.ID_TOKEN]);
                            return (
                                f
                                    ? (a.expiresOn = new Date(1e3 * f))
                                    : this.logger.error('Could not parse expiresIn parameter'),
                                a
                            );
                        }),
                        (l.prototype.saveTokenFromHash = function (e, t) {
                            this.logger.info(
                                `State status:${t.stateMatch}; Request type:${t.requestType}`
                            );
                            let r;
                            let n;
                            let o = {
                                uniqueId: '',
                                tenantId: '',
                                tokenType: '',
                                idToken: null,
                                idTokenClaims: null,
                                accessToken: null,
                                scopes: [],
                                expiresOn: null,
                                account: null,
                                accountState: '',
                                fromCache: !1,
                            };
                            const i = b.UrlUtils.deserializeHash(e);
                            let a = '';
                            let s = '';
                            let c = null;
                            if (
                                i.hasOwnProperty(K.ServerHashParamKeys.ERROR_DESCRIPTION) ||
                                i.hasOwnProperty(K.ServerHashParamKeys.ERROR)
                            ) {
                                this.logger.infoPii(
                                    `Error :${i[K.ServerHashParamKeys.ERROR]}; Error description:${
                                        i[K.ServerHashParamKeys.ERROR_DESCRIPTION]
                                    }`
                                ),
                                    this.cacheStorage.setItem(
                                        K.ErrorCacheKeys.ERROR,
                                        i[K.ServerHashParamKeys.ERROR]
                                    ),
                                    this.cacheStorage.setItem(
                                        K.ErrorCacheKeys.ERROR_DESC,
                                        i[K.ServerHashParamKeys.ERROR_DESCRIPTION]
                                    ),
                                    t.requestType === K.Constants.login &&
                                        (this.cacheStorage.setItem(
                                            K.ErrorCacheKeys.LOGIN_ERROR,
                                            `${i[K.ServerHashParamKeys.ERROR_DESCRIPTION]}:${
                                                i[K.ServerHashParamKeys.ERROR]
                                            }`
                                        ),
                                        (a = T.AuthCache.generateAuthorityKey(t.state))),
                                    t.requestType === K.Constants.renewToken &&
                                        ((a = T.AuthCache.generateAuthorityKey(t.state)),
                                        (n = void 0),
                                        (n =
                                            (r = this.getAccount()) &&
                                            !A.StringUtils.isEmpty(r.homeAccountIdentifier)
                                                ? r.homeAccountIdentifier
                                                : K.Constants.no_account),
                                        (s = T.AuthCache.generateAcquireTokenAccountKey(
                                            n,
                                            t.state
                                        )));
                                const u = i[K.ServerHashParamKeys.ERROR];
                                const l = i[K.ServerHashParamKeys.ERROR_DESCRIPTION];
                                var h =
                                    M.InteractionRequiredAuthError.isInteractionRequiredError(u) ||
                                    M.InteractionRequiredAuthError.isInteractionRequiredError(l)
                                        ? new M.InteractionRequiredAuthError(
                                              i[K.ServerHashParamKeys.ERROR],
                                              i[K.ServerHashParamKeys.ERROR_DESCRIPTION]
                                          )
                                        : new U.ServerError(
                                              i[K.ServerHashParamKeys.ERROR],
                                              i[K.ServerHashParamKeys.ERROR_DESCRIPTION]
                                          );
                            } else if (t.stateMatch) {
                                this.logger.info('State is right'),
                                    i.hasOwnProperty(K.ServerHashParamKeys.SESSION_STATE) &&
                                        this.cacheStorage.setItem(
                                            `${K.TemporaryCacheKeys.SESSION_STATE}${K.Constants.resourceDelimiter}${t.state}`,
                                            i[K.ServerHashParamKeys.SESSION_STATE]
                                        ),
                                    (o.accountState = this.getAccountState(t.state));
                                let d = '';
                                if (i.hasOwnProperty(K.ServerHashParamKeys.ACCESS_TOKEN)) {
                                    this.logger.info('Fragment has access token'),
                                        i.hasOwnProperty(K.ServerHashParamKeys.ID_TOKEN)
                                            ? ((c = new I.IdToken(
                                                  i[K.ServerHashParamKeys.ID_TOKEN]
                                              )),
                                              (o.idToken = c),
                                              (o.idTokenClaims = c.claims))
                                            : ((c = new I.IdToken(
                                                  this.cacheStorage.getItem(
                                                      K.PersistentCacheKeys.IDTOKEN
                                                  )
                                              )),
                                              (o = R.ResponseUtils.setResponseIdToken(o, c)));
                                    var p = this.populateAuthority(
                                        t.state,
                                        this.inCookie,
                                        this.cacheStorage,
                                        c
                                    );
                                    if (!i.hasOwnProperty(K.ServerHashParamKeys.CLIENT_INFO))
                                        throw (
                                            (this.logger.warning(
                                                'ClientInfo not received in the response from AAD'
                                            ),
                                            N.ClientAuthError.createClientInfoNotPopulatedError(
                                                'ClientInfo not received in the response from the server'
                                            ))
                                        );
                                    (d = i[K.ServerHashParamKeys.CLIENT_INFO]),
                                        (o.account = S.Account.createAccount(
                                            c,
                                            new v.ClientInfo(d)
                                        ));
                                    var f = void 0;
                                    var f =
                                        o.account &&
                                        !A.StringUtils.isEmpty(o.account.homeAccountIdentifier)
                                            ? o.account.homeAccountIdentifier
                                            : K.Constants.no_account;
                                    s = T.AuthCache.generateAcquireTokenAccountKey(f, t.state);
                                    let g;
                                    const y = T.AuthCache.generateAcquireTokenAccountKey(
                                        K.Constants.no_account,
                                        t.state
                                    );
                                    const m = this.cacheStorage.getItem(s);
                                    A.StringUtils.isEmpty(m)
                                        ? A.StringUtils.isEmpty(this.cacheStorage.getItem(y)) ||
                                          (o = this.saveAccessToken(o, p, i, d, c))
                                        : ((g = JSON.parse(m)),
                                          o.account && g && S.Account.compareAccounts(o.account, g)
                                              ? ((o = this.saveAccessToken(o, p, i, d, c)),
                                                this.logger.info(
                                                    'The user object received in the response is the same as the one passed in the acquireToken request'
                                                ))
                                              : this.logger.warning(
                                                    'The account object created from the response is not the same as the one passed in the acquireToken request'
                                                ));
                                }
                                i.hasOwnProperty(K.ServerHashParamKeys.ID_TOKEN) &&
                                    (this.logger.info('Fragment has id token'),
                                    (c = new I.IdToken(i[K.ServerHashParamKeys.ID_TOKEN])),
                                    (o = R.ResponseUtils.setResponseIdToken(o, c)),
                                    i.hasOwnProperty(K.ServerHashParamKeys.CLIENT_INFO)
                                        ? (d = i[K.ServerHashParamKeys.CLIENT_INFO])
                                        : this.logger.warning(
                                              'ClientInfo not received in the response from AAD'
                                          ),
                                    (p = this.populateAuthority(
                                        t.state,
                                        this.inCookie,
                                        this.cacheStorage,
                                        c
                                    )),
                                    (this.account = S.Account.createAccount(
                                        c,
                                        new v.ClientInfo(d)
                                    )),
                                    (o.account = this.account),
                                    c && c.nonce
                                        ? c.nonce !==
                                          this.cacheStorage.getItem(
                                              `${K.TemporaryCacheKeys.NONCE_IDTOKEN}${K.Constants.resourceDelimiter}${t.state}`,
                                              this.inCookie
                                          )
                                            ? ((this.account = null),
                                              this.cacheStorage.setItem(
                                                  K.ErrorCacheKeys.LOGIN_ERROR,
                                                  `Nonce Mismatch. Expected Nonce: ${this.cacheStorage.getItem(
                                                      `${K.TemporaryCacheKeys.NONCE_IDTOKEN}${K.Constants.resourceDelimiter}${t.state}`,
                                                      this.inCookie
                                                  )},Actual Nonce: ${c.nonce}`
                                              ),
                                              this.logger.error(
                                                  `Nonce Mismatch.Expected Nonce: ${this.cacheStorage.getItem(
                                                      `${K.TemporaryCacheKeys.NONCE_IDTOKEN}${K.Constants.resourceDelimiter}${t.state}`,
                                                      this.inCookie
                                                  )},Actual Nonce: ${c.nonce}`
                                              ),
                                              (h = N.ClientAuthError.createNonceMismatchError(
                                                  this.cacheStorage.getItem(
                                                      `${K.TemporaryCacheKeys.NONCE_IDTOKEN}${K.Constants.resourceDelimiter}${t.state}`,
                                                      this.inCookie
                                                  ),
                                                  c.nonce
                                              )))
                                            : (this.cacheStorage.setItem(
                                                  K.PersistentCacheKeys.IDTOKEN,
                                                  i[K.ServerHashParamKeys.ID_TOKEN]
                                              ),
                                              this.cacheStorage.setItem(
                                                  K.PersistentCacheKeys.CLIENT_INFO,
                                                  d
                                              ),
                                              this.saveAccessToken(o, p, i, d, c))
                                        : ((a = t.state),
                                          (s = t.state),
                                          this.logger.error(
                                              'Invalid id_token received in the response'
                                          ),
                                          (h = N.ClientAuthError.createInvalidIdTokenError(c)),
                                          this.cacheStorage.setItem(
                                              K.ErrorCacheKeys.ERROR,
                                              h.errorCode
                                          ),
                                          this.cacheStorage.setItem(
                                              K.ErrorCacheKeys.ERROR_DESC,
                                              h.errorMessage
                                          )));
                            } else {
                                (a = t.state), (s = t.state);
                                const E = this.cacheStorage.getItem(
                                    `${K.TemporaryCacheKeys.STATE_LOGIN}${K.Constants.resourceDelimiter}${t.state}`,
                                    this.inCookie
                                );
                                this.logger.error(
                                    `State Mismatch.Expected State: ${E},Actual State: ${t.state}`
                                ),
                                    (h = N.ClientAuthError.createInvalidStateError(t.state, E)),
                                    this.cacheStorage.setItem(K.ErrorCacheKeys.ERROR, h.errorCode),
                                    this.cacheStorage.setItem(
                                        K.ErrorCacheKeys.ERROR_DESC,
                                        h.errorMessage
                                    );
                            }
                            if (
                                (this.cacheStorage.removeItem(
                                    `${K.TemporaryCacheKeys.RENEW_STATUS}${K.Constants.resourceDelimiter}${t.state}`
                                ),
                                this.cacheStorage.resetTempCacheItems(t.state),
                                this.inCookie &&
                                    (this.cacheStorage.setItemCookie(a, '', -1),
                                    this.cacheStorage.clearMsalCookie(t.state)),
                                h)
                            )
                                throw h;
                            if (!o) throw k.AuthError.createUnexpectedError('Response is null');
                            return o;
                        }),
                        (l.prototype.populateAuthority = function (e, t, r, n) {
                            const o = T.AuthCache.generateAuthorityKey(e);
                            const i = r.getItem(o, t);
                            return A.StringUtils.isEmpty(i)
                                ? i
                                : b.UrlUtils.replaceTenantPath(i, n.tenantId);
                        }),
                        (l.prototype.getAccount = function () {
                            if (this.account) return this.account;
                            const e = this.cacheStorage.getItem(K.PersistentCacheKeys.IDTOKEN);
                            const t = this.cacheStorage.getItem(K.PersistentCacheKeys.CLIENT_INFO);
                            if (A.StringUtils.isEmpty(e) || A.StringUtils.isEmpty(t)) return null;
                            const r = new I.IdToken(e);
                            const n = new v.ClientInfo(t);
                            return (this.account = S.Account.createAccount(r, n)), this.account;
                        }),
                        (l.prototype.getAccountState = function (e) {
                            if (e) {
                                const t = e.indexOf('|');
                                if (t > -1 && t + 1 < e.length)
                                    return (
                                        this.cacheStorage.setItem(
                                            K.PersistentCacheKeys.CLIENT_ROUTE,
                                            e.substring(t + 1)
                                        ),
                                        e.substring(t + 1)
                                    );
                            }
                            return e;
                        }),
                        (l.prototype.removeAccountRoute = function () {
                            this.cacheStorage.removeItem(K.PersistentCacheKeys.CLIENT_ROUTE);
                        }),
                        (l.prototype.getAccountRoute = function () {
                            const e = this.cacheStorage.getItem(K.PersistentCacheKeys.CLIENT_ROUTE);
                            return e || null;
                        }),
                        (l.prototype.getAllAccounts = function () {
                            for (
                                var e = [],
                                    t = this.cacheStorage.getAllAccessTokens(
                                        K.Constants.clientId,
                                        K.Constants.homeAccountIdentifier
                                    ),
                                    r = 0;
                                r < t.length;
                                r++
                            ) {
                                const n = new I.IdToken(t[r].value.idToken);
                                const o = new v.ClientInfo(t[r].value.homeAccountIdentifier);
                                const i = S.Account.createAccount(n, o);
                                e.push(i);
                            }
                            return this.getUniqueAccounts(e);
                        }),
                        (l.prototype.getUniqueAccounts = function (e) {
                            if (!e || e.length <= 1) return e;
                            for (var t = [], r = [], n = 0; n < e.length; ++n)
                                e[n].homeAccountIdentifier &&
                                    t.indexOf(e[n].homeAccountIdentifier) === -1 &&
                                    (t.push(e[n].homeAccountIdentifier), r.push(e[n]));
                            return r;
                        }),
                        (l.prototype.broadcast = function (e, t) {
                            const r = new CustomEvent(e, { detail: t });
                            window.dispatchEvent(r);
                        }),
                        (l.prototype.getCachedTokenInternal = function (e, t, r, n) {
                            const o = t || this.getAccount();
                            if (!o) return null;
                            const i = this.authorityInstance
                                ? this.authorityInstance
                                : P.AuthorityFactory.CreateInstance(
                                      this.authority,
                                      this.config.auth.validateAuthority
                                  );
                            const a = this.getTokenType(o, e, !0);
                            const s = new y.ServerRequestParameters(
                                i,
                                this.clientId,
                                a,
                                this.getRedirectUri(),
                                e,
                                r,
                                n
                            );
                            return this.getCachedToken(s, t);
                        }),
                        (l.prototype.getScopesForEndpoint = function (e) {
                            if (this.config.framework.unprotectedResources.length > 0)
                                for (
                                    let t = 0;
                                    t < this.config.framework.unprotectedResources.length;
                                    t++
                                )
                                    if (
                                        e.indexOf(this.config.framework.unprotectedResources[t]) >
                                        -1
                                    )
                                        return null;
                            if (this.config.framework.protectedResourceMap.size > 0)
                                for (
                                    let r = 0,
                                        n = Array.from(
                                            this.config.framework.protectedResourceMap.keys()
                                        );
                                    r < n.length;
                                    r++
                                ) {
                                    const o = n[r];
                                    if (e.indexOf(o) > -1)
                                        return this.config.framework.protectedResourceMap.get(o);
                                }
                            return (e.indexOf('http://') > -1 || e.indexOf('https://') > -1) &&
                                b.UrlUtils.getHostFromUri(e) !==
                                    b.UrlUtils.getHostFromUri(this.getRedirectUri())
                                ? null
                                : new Array(this.clientId);
                        }),
                        (l.prototype.getLoginInProgress = function () {
                            return (
                                !!this.cacheStorage.getItem(K.TemporaryCacheKeys.URL_HASH) ||
                                this.cacheStorage.getItem(
                                    K.TemporaryCacheKeys.INTERACTION_STATUS
                                ) === K.Constants.inProgress
                            );
                        }),
                        (l.prototype.setInteractionInProgress = function (e) {
                            e
                                ? this.cacheStorage.setItem(
                                      K.TemporaryCacheKeys.INTERACTION_STATUS,
                                      K.Constants.inProgress
                                  )
                                : this.cacheStorage.removeItem(
                                      K.TemporaryCacheKeys.INTERACTION_STATUS
                                  );
                        }),
                        (l.prototype.setloginInProgress = function (e) {
                            this.setInteractionInProgress(e);
                        }),
                        (l.prototype.getAcquireTokenInProgress = function () {
                            return (
                                this.cacheStorage.getItem(
                                    K.TemporaryCacheKeys.INTERACTION_STATUS
                                ) === K.Constants.inProgress
                            );
                        }),
                        (l.prototype.setAcquireTokenInProgress = function (e) {
                            this.setInteractionInProgress(e);
                        }),
                        (l.prototype.getLogger = function () {
                            return this.config.system.logger;
                        }),
                        (l.prototype.getRedirectUri = function (e) {
                            return (
                                e ||
                                (typeof this.config.auth.redirectUri === 'function'
                                    ? this.config.auth.redirectUri()
                                    : this.config.auth.redirectUri)
                            );
                        }),
                        (l.prototype.getPostLogoutRedirectUri = function () {
                            return typeof this.config.auth.postLogoutRedirectUri === 'function'
                                ? this.config.auth.postLogoutRedirectUri()
                                : this.config.auth.postLogoutRedirectUri;
                        }),
                        (l.prototype.getCurrentConfiguration = function () {
                            if (!this.config)
                                throw a.ClientConfigurationError.createNoSetConfigurationError();
                            return this.config;
                        }),
                        (l.prototype.getTokenType = function (e, t, r) {
                            return r
                                ? S.Account.compareAccounts(e, this.getAccount())
                                    ? t.indexOf(this.config.auth.clientId) > -1
                                        ? L
                                        : i
                                    : t.indexOf(this.config.auth.clientId) > -1
                                    ? L
                                    : c
                                : S.Account.compareAccounts(e, this.getAccount())
                                ? t.indexOf(this.clientId) > -1
                                    ? L
                                    : i
                                : c;
                        }),
                        (l.prototype.setAccountCache = function (e, t) {
                            const r = e ? this.getAccountId(e) : K.Constants.no_account;
                            const n = T.AuthCache.generateAcquireTokenAccountKey(r, t);
                            this.cacheStorage.setItem(n, JSON.stringify(e));
                        }),
                        (l.prototype.setAuthorityCache = function (e, t) {
                            const r = T.AuthCache.generateAuthorityKey(e);
                            this.cacheStorage.setItem(
                                r,
                                b.UrlUtils.CanonicalizeUri(t),
                                this.inCookie
                            );
                        }),
                        (l.prototype.updateCacheEntries = function (e, t, r) {
                            r
                                ? (this.cacheStorage.setItem(
                                      `${K.TemporaryCacheKeys.LOGIN_REQUEST}${K.Constants.resourceDelimiter}${e.state}`,
                                      r,
                                      this.inCookie
                                  ),
                                  this.cacheStorage.setItem(
                                      `${K.TemporaryCacheKeys.STATE_LOGIN}${K.Constants.resourceDelimiter}${e.state}`,
                                      e.state,
                                      this.inCookie
                                  ))
                                : this.setAccountCache(t, e.state),
                                this.setAuthorityCache(e.state, e.authority),
                                this.cacheStorage.setItem(
                                    `${K.TemporaryCacheKeys.NONCE_IDTOKEN}${K.Constants.resourceDelimiter}${e.state}`,
                                    e.nonce,
                                    this.inCookie
                                );
                        }),
                        (l.prototype.getAccountId = function (e) {
                            const t = A.StringUtils.isEmpty(e.homeAccountIdentifier)
                                ? K.Constants.no_account
                                : e.homeAccountIdentifier;
                            return t;
                        }),
                        (l.prototype.buildIDTokenRequest = function (e) {
                            return {
                                scopes: [this.clientId],
                                authority: this.authority,
                                account: this.getAccount(),
                                extraQueryParameters: e.extraQueryParameters,
                            };
                        }),
                        (l.prototype.getTelemetryManagerFromConfig = function (e, t) {
                            if (!e) return null;
                            const r = e.applicationName;
                            const n = e.applicationVersion;
                            const o = e.telemetryEmitter;
                            if (!r || !n || !o)
                                throw a.ClientConfigurationError.createTelemetryConfigError(e);
                            const i = {
                                platform: {
                                    sdk: 'msal.js',
                                    sdkVersion: K.libraryVersion(),
                                    applicationName: r,
                                    applicationVersion: n,
                                },
                                clientId: t,
                            };
                            return new s.default(i, o);
                        }),
                        l);
                    function l(e) {
                        (this.authResponseCallback = null),
                            (this.tokenReceivedCallback = null),
                            (this.errorReceivedCallback = null),
                            (this.config = n.buildConfiguration(e)),
                            (this.redirectCallbacksSet = !1),
                            (this.logger = this.config.system.logger),
                            (this.clientId = this.config.auth.clientId),
                            (this.inCookie = this.config.cache.storeAuthStateInCookie),
                            (this.telemetryManager = this.getTelemetryManagerFromConfig(
                                this.config.system.telemetry,
                                this.clientId
                            )),
                            (this.authority =
                                this.config.auth.authority ||
                                'https://login.microsoftonline.com/common'),
                            (this.cacheStorage = new T.AuthCache(
                                this.clientId,
                                this.config.cache.cacheLocation,
                                this.inCookie
                            )),
                            (window.activeRenewals = {}),
                            (window.renewStates = []),
                            (window.callbackMappedToRenewStates = {}),
                            (window.promiseMappedToRenewStates = {}),
                            (window.msal = this);
                        const t = window.location.hash;
                        const r = b.UrlUtils.urlContainsHash(t);
                        w.WindowUtils.checkIfBackButtonIsPressed(this.cacheStorage),
                            !r ||
                                w.WindowUtils.isInIframe() ||
                                w.WindowUtils.isInPopup() ||
                                this.handleAuthenticationResponse(t);
                    }
                    t.UserAgentApplication = u;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const o = r(2);
                    const n = r(1);
                    const i =
                        ((a.decodeJwt = function (e) {
                            if (n.StringUtils.isEmpty(e)) return null;
                            const t = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/.exec(e);
                            return !t || t.length < 4
                                ? null
                                : { header: t[1], JWSPayload: t[2], JWSSig: t[3] };
                        }),
                        (a.extractIdToken = function (e) {
                            const t = this.decodeJwt(e);
                            if (!t) return null;
                            try {
                                const r = t.JWSPayload;
                                const n = o.CryptoUtils.base64Decode(r);
                                return n ? JSON.parse(n) : null;
                            } catch (e) {}
                            return null;
                        }),
                        a);
                    function a() {}
                    t.TokenUtils = i;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const a = r(2);
                    const s = r(1);
                    const n =
                        ((c.createAccount = function (e, t) {
                            let r;
                            const n = e.objectId || e.subject;
                            const o = t ? t.uid : '';
                            const i = t ? t.utid : '';
                            return (
                                s.StringUtils.isEmpty(o) ||
                                    s.StringUtils.isEmpty(i) ||
                                    (r = `${a.CryptoUtils.base64Encode(
                                        o
                                    )}.${a.CryptoUtils.base64Encode(i)}`),
                                new c(n, r, e.preferredName, e.name, e.claims, e.sid, e.issuer)
                            );
                        }),
                        (c.compareAccounts = function (e, t) {
                            return !!(
                                e &&
                                t &&
                                e.homeAccountIdentifier &&
                                t.homeAccountIdentifier &&
                                e.homeAccountIdentifier === t.homeAccountIdentifier
                            );
                        }),
                        c);
                    function c(e, t, r, n, o, i, a) {
                        (this.accountIdentifier = e),
                            (this.homeAccountIdentifier = t),
                            (this.userName = r),
                            (this.name = n),
                            (this.idToken = o),
                            (this.idTokenClaims = o),
                            (this.sid = i),
                            (this.environment = a);
                    }
                    t.Account = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let n;
                    const o = r(0);
                    const i = r(8);
                    const a = r(17);
                    const s = r(3);
                    const c =
                        ((n = i.Authority),
                        o.__extends(u, n),
                        Object.defineProperty(u.prototype, 'AadInstanceDiscoveryEndpointUrl', {
                            get() {
                                return `${u.AadInstanceDiscoveryEndpoint}?api-version=1.0&authorization_endpoint=${this.CanonicalAuthority}oauth2/v2.0/authorize`;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(u.prototype, 'AuthorityType', {
                            get() {
                                return i.AuthorityType.Aad;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (u.prototype.GetOpenIdConfigurationEndpointAsync = function () {
                            return o.__awaiter(this, void 0, Promise, function () {
                                return o.__generator(this, function (e) {
                                    return !this.IsValidationEnabled ||
                                        this.IsInTrustedHostList(
                                            this.CanonicalAuthorityUrlComponents.HostNameAndPort
                                        )
                                        ? [2, this.DefaultOpenIdConfigurationEndpoint]
                                        : [
                                              2,
                                              new a.XhrClient()
                                                  .sendRequestAsync(
                                                      this.AadInstanceDiscoveryEndpointUrl,
                                                      'GET',
                                                      !0
                                                  )
                                                  .then((e) => e.tenant_discovery_endpoint),
                                          ];
                                });
                            });
                        }),
                        (u.prototype.IsInTrustedHostList = function (e) {
                            return s.AADTrustedHostList[e.toLowerCase()];
                        }),
                        (u.AadInstanceDiscoveryEndpoint =
                            'https://login.microsoftonline.com/common/discovery/instance'),
                        u);
                    function u(e, t) {
                        return n.call(this, e, t) || this;
                    }
                    t.AadAuthority = c;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n =
                        ((o.prototype.sendRequestAsync = function (e, t, r) {
                            const i = this;
                            return new Promise((r, n) => {
                                const o = new XMLHttpRequest();
                                if (
                                    (o.open(t, e, !0),
                                    (o.onload = function (e) {
                                        let t;
                                        (o.status < 200 || o.status >= 300) &&
                                            n(i.handleError(o.responseText));
                                        try {
                                            t = JSON.parse(o.responseText);
                                        } catch (e) {
                                            n(i.handleError(o.responseText));
                                        }
                                        r(t);
                                    }),
                                    (o.onerror = function (e) {
                                        n(o.status);
                                    }),
                                    t !== 'GET')
                                )
                                    throw 'not implemented';
                                o.send();
                            });
                        }),
                        (o.prototype.handleError = function (t) {
                            let e;
                            try {
                                if ((e = JSON.parse(t)).error) return e.error;
                                throw t;
                            } catch (e) {
                                return t;
                            }
                        }),
                        o);
                    function o() {}
                    t.XhrClient = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let i;
                    const n = r(0);
                    const o = r(16);
                    const a = r(8);
                    const s = r(4);
                    const c = r(5);
                    const u =
                        ((i = o.AadAuthority),
                        n.__extends(l, i),
                        Object.defineProperty(l.prototype, 'AuthorityType', {
                            get() {
                                return a.AuthorityType.B2C;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (l.prototype.GetOpenIdConfigurationEndpointAsync = function () {
                            return n.__awaiter(this, void 0, Promise, function () {
                                return n.__generator(this, function (e) {
                                    if (
                                        !this.IsValidationEnabled ||
                                        this.IsInTrustedHostList(
                                            this.CanonicalAuthorityUrlComponents.HostNameAndPort
                                        )
                                    )
                                        return [2, this.DefaultOpenIdConfigurationEndpoint];
                                    throw s.ClientConfigurationErrorMessage
                                        .unsupportedAuthorityValidation;
                                });
                            });
                        }),
                        (l.B2C_PREFIX = 'tfp'),
                        l);
                    function l(e, t) {
                        const r = i.call(this, e, t) || this;
                        const n = c.UrlUtils.GetUrlComponents(e);
                        const o = n.PathSegments;
                        if (o.length < 3)
                            throw s.ClientConfigurationErrorMessage.b2cAuthorityUriInvalidPath;
                        return (
                            (r.CanonicalAuthority = `https://${n.HostNameAndPort}/${o[0]}/${o[1]}/${o[2]}/`),
                            r
                        );
                    }
                    t.B2cAuthority = u;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const c = r(0);
                    const n = r(11);
                    const o = r(5);
                    const u = {
                        clientId: '',
                        authority: null,
                        validateAuthority: !0,
                        redirectUri() {
                            return o.UrlUtils.getDefaultRedirectUri();
                        },
                        postLogoutRedirectUri() {
                            return o.UrlUtils.getDefaultRedirectUri();
                        },
                        navigateToLoginRequestUrl: !0,
                    };
                    const l = { cacheLocation: 'sessionStorage', storeAuthStateInCookie: !1 };
                    const h = {
                        logger: new n.Logger(null),
                        loadFrameTimeout: 6e3,
                        tokenRenewalOffsetSeconds: 300,
                        navigateFrameWait: 500,
                    };
                    const d = {
                        isAngular: !1,
                        unprotectedResources: new Array(),
                        protectedResourceMap: new Map(),
                    };
                    t.buildConfiguration = function (e) {
                        const t = e.auth;
                        const r = e.cache;
                        const n = void 0 === r ? {} : r;
                        const o = e.system;
                        const i = void 0 === o ? {} : o;
                        const a = e.framework;
                        const s = void 0 === a ? {} : a;
                        return {
                            auth: c.__assign({}, u, t),
                            cache: c.__assign({}, l, n),
                            system: c.__assign({}, h, i),
                            framework: c.__assign({}, d, s),
                        };
                    };
                },
                function (e, r, t) {
                    Object.defineProperty(r, '__esModule', { value: !0 });
                    const n = t(0);
                    const o = t(12);
                    r.InteractionRequiredAuthErrorMessage = {
                        interactionRequired: { code: 'interaction_required' },
                        consentRequired: { code: 'consent_required' },
                        loginRequired: { code: 'login_required' },
                    };
                    let i;
                    const a =
                        ((i = o.ServerError),
                        n.__extends(s, i),
                        (s.isInteractionRequiredError = function (e) {
                            const t = [
                                r.InteractionRequiredAuthErrorMessage.interactionRequired.code,
                                r.InteractionRequiredAuthErrorMessage.consentRequired.code,
                                r.InteractionRequiredAuthErrorMessage.loginRequired.code,
                            ];
                            return e && t.indexOf(e) > -1;
                        }),
                        (s.createLoginRequiredAuthError = function (e) {
                            return new s(
                                r.InteractionRequiredAuthErrorMessage.loginRequired.code,
                                e
                            );
                        }),
                        (s.createInteractionRequiredAuthError = function (e) {
                            return new s(
                                r.InteractionRequiredAuthErrorMessage.interactionRequired.code,
                                e
                            );
                        }),
                        (s.createConsentRequiredAuthError = function (e) {
                            return new s(
                                r.InteractionRequiredAuthErrorMessage.consentRequired.code,
                                e
                            );
                        }),
                        s);
                    function s(e, t) {
                        const r = i.call(this, e, t) || this;
                        return (
                            (r.name = 'InteractionRequiredAuthError'),
                            Object.setPrototypeOf(r, s.prototype),
                            r
                        );
                    }
                    r.InteractionRequiredAuthError = a;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 }),
                        (t.buildResponseStateOnly = function (e) {
                            return {
                                uniqueId: '',
                                tenantId: '',
                                tokenType: '',
                                idToken: null,
                                idTokenClaims: null,
                                accessToken: '',
                                scopes: null,
                                expiresOn: null,
                                account: null,
                                accountState: e,
                                fromCache: !1,
                            };
                        });
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const o = r(18);
                    const i = r(3);
                    const a = r(9);
                    const n = r(2);
                    const s = r(5);
                    (t.scrubTenantFromUri = function (e) {
                        const t = s.UrlUtils.GetUrlComponents(e);
                        if (!i.AADTrustedHostList[t.HostNameAndPort.toLocaleLowerCase()])
                            return null;
                        let r;
                        const n = t.PathSegments;
                        return (
                            n &&
                                n.length >= 2 &&
                                (r = n[1] === o.B2cAuthority.B2C_PREFIX ? 2 : 1) < n.length &&
                                (n[r] = a.TENANT_PLACEHOLDER),
                            `${t.Protocol}//${t.HostNameAndPort}/${n.join('/')}`
                        );
                    }),
                        (t.hashPersonalIdentifier = function (e) {
                            return n.CryptoUtils.base64Encode(e);
                        }),
                        (t.prependEventNamePrefix = function (e) {
                            return `${a.EVENT_NAME_PREFIX}${e || ''}`;
                        });
                },
                function (e, t, r) {
                    e.exports = r(24);
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(13);
                    t.UserAgentApplication = n.UserAgentApplication;
                    const o = r(11);
                    t.Logger = o.Logger;
                    const i = r(11);
                    t.LogLevel = i.LogLevel;
                    const a = r(15);
                    t.Account = a.Account;
                    const s = r(3);
                    t.Constants = s.Constants;
                    const c = r(8);
                    t.Authority = c.Authority;
                    const u = r(13);
                    t.CacheResult = u.CacheResult;
                    const l = r(19);
                    (t.CacheLocation = l.CacheLocation), (t.Configuration = l.Configuration);
                    const h = r(41);
                    t.AuthenticationParameters = h.AuthenticationParameters;
                    const d = r(21);
                    t.AuthResponse = d.AuthResponse;
                    const p = r(2);
                    t.CryptoUtils = p.CryptoUtils;
                    const f = r(7);
                    t.AuthError = f.AuthError;
                    const g = r(6);
                    t.ClientAuthError = g.ClientAuthError;
                    const y = r(12);
                    t.ServerError = y.ServerError;
                    const m = r(4);
                    t.ClientConfigurationError = m.ClientConfigurationError;
                    const E = r(20);
                    t.InteractionRequiredAuthError = E.InteractionRequiredAuthError;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    function n(e, t, r, n, o) {
                        (this.authority = a.UrlUtils.CanonicalizeUri(e)),
                            (this.clientId = t),
                            (this.scopes = r),
                            (this.homeAccountIdentifier = `${i.CryptoUtils.base64Encode(
                                n
                            )}.${i.CryptoUtils.base64Encode(o)}`);
                    }
                    var i = r(2);
                    var a = r(5);
                    t.AccessTokenKey = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    function n(e, t, r, n) {
                        (this.accessToken = e),
                            (this.idToken = t),
                            (this.expiresIn = r),
                            (this.homeAccountIdentifier = n);
                    }
                    t.AccessTokenValue = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const s = r(2);
                    const c = r(3);
                    const n = r(1);
                    const o =
                        (Object.defineProperty(i.prototype, 'authority', {
                            get() {
                                return this.authorityInstance
                                    ? this.authorityInstance.CanonicalAuthority
                                    : null;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (i.prototype.populateQueryParams = function (e, t, r) {
                            let n = {};
                            t &&
                                (t.prompt && (this.promptValue = t.prompt),
                                t.claimsRequest && (this.claimsValue = t.claimsRequest),
                                i.isSSOParam(t) &&
                                    (n = this.constructUnifiedCacheQueryParameter(t, null))),
                                r && (n = this.constructUnifiedCacheQueryParameter(null, r)),
                                (n = this.addHintParameters(e, n));
                            const o = t.extraQueryParameters;
                            (this.queryParameters = i.generateQueryParametersString(n)),
                                (this.extraQueryParameters = i.generateQueryParametersString(o));
                        }),
                        (i.prototype.constructUnifiedCacheQueryParameter = function (e, t) {
                            let r;
                            let n;
                            let o;
                            let i = {};
                            return (
                                e
                                    ? e.account
                                        ? (o = e.account).sid
                                            ? ((r = c.SSOTypes.SID), (n = o.sid))
                                            : o.userName &&
                                              ((r = c.SSOTypes.LOGIN_HINT), (n = o.userName))
                                        : e.sid
                                        ? ((r = c.SSOTypes.SID), (n = e.sid))
                                        : e.loginHint &&
                                          ((r = c.SSOTypes.LOGIN_HINT), (n = e.loginHint))
                                    : t &&
                                      (n = t.hasOwnProperty(c.Constants.upn)
                                          ? ((r = c.SSOTypes.ID_TOKEN), t.upn)
                                          : ((r = c.SSOTypes.ORGANIZATIONS), null)),
                                (i = this.addSSOParameter(r, n)),
                                e &&
                                    e.account &&
                                    e.account.homeAccountIdentifier &&
                                    (i = this.addSSOParameter(
                                        c.SSOTypes.HOMEACCOUNT_ID,
                                        e.account.homeAccountIdentifier,
                                        i
                                    )),
                                i
                            );
                        }),
                        (i.prototype.addHintParameters = function (e, t) {
                            return (
                                e &&
                                    !t[c.SSOTypes.SID] &&
                                    (!t[c.SSOTypes.LOGIN_HINT] &&
                                    e.sid &&
                                    this.promptValue === c.PromptState.NONE
                                        ? (t = this.addSSOParameter(c.SSOTypes.SID, e.sid, t))
                                        : t[c.SSOTypes.LOGIN_HINT] ||
                                          !e.userName ||
                                          n.StringUtils.isEmpty(e.userName) ||
                                          (t = this.addSSOParameter(
                                              c.SSOTypes.LOGIN_HINT,
                                              e.userName,
                                              t
                                          )),
                                    t[c.SSOTypes.DOMAIN_REQ] ||
                                        t[c.SSOTypes.LOGIN_REQ] ||
                                        (t = this.addSSOParameter(
                                            c.SSOTypes.HOMEACCOUNT_ID,
                                            e.homeAccountIdentifier,
                                            t
                                        ))),
                                t
                            );
                        }),
                        (i.prototype.addSSOParameter = function (e, t, r) {
                            if (((r = r || {}), !t)) return r;
                            switch (e) {
                                case c.SSOTypes.SID:
                                    r[c.SSOTypes.SID] = t;
                                    break;
                                case c.SSOTypes.ID_TOKEN:
                                    (r[c.SSOTypes.LOGIN_HINT] = t),
                                        (r[c.SSOTypes.DOMAIN_HINT] = c.SSOTypes.ORGANIZATIONS);
                                    break;
                                case c.SSOTypes.LOGIN_HINT:
                                    r[c.SSOTypes.LOGIN_HINT] = t;
                                    break;
                                case c.SSOTypes.ORGANIZATIONS:
                                    r[c.SSOTypes.DOMAIN_HINT] = c.SSOTypes.ORGANIZATIONS;
                                    break;
                                case c.SSOTypes.CONSUMERS:
                                    r[c.SSOTypes.DOMAIN_HINT] = c.SSOTypes.CONSUMERS;
                                    break;
                                case c.SSOTypes.HOMEACCOUNT_ID:
                                    var n = t.split('.');
                                    var o = s.CryptoUtils.base64Decode(n[0]);
                                    var i = s.CryptoUtils.base64Decode(n[1]);
                                    (r[c.SSOTypes.LOGIN_REQ] = o),
                                        (r[c.SSOTypes.DOMAIN_REQ] = i) === c.Constants.consumersUtid
                                            ? (r[c.SSOTypes.DOMAIN_HINT] = c.SSOTypes.CONSUMERS)
                                            : (r[c.SSOTypes.DOMAIN_HINT] =
                                                  c.SSOTypes.ORGANIZATIONS);
                                    break;
                                case c.SSOTypes.LOGIN_REQ:
                                    r[c.SSOTypes.LOGIN_REQ] = t;
                                    break;
                                case c.SSOTypes.DOMAIN_REQ:
                                    r[c.SSOTypes.DOMAIN_REQ] = t;
                            }
                            return r;
                        }),
                        (i.generateQueryParametersString = function (t) {
                            let r = null;
                            return (
                                t &&
                                    Object.keys(t).forEach((e) => {
                                        r == null
                                            ? (r = `${e}=${encodeURIComponent(t[e])}`)
                                            : (r += `&${e}=${encodeURIComponent(t[e])}`);
                                    }),
                                r
                            );
                        }),
                        (i.isSSOParam = function (e) {
                            return e && (e.account || e.sid || e.loginHint);
                        }),
                        i);
                    function i(e, t, r, n, o, i, a) {
                        (this.authorityInstance = e),
                            (this.clientId = t),
                            (this.nonce = s.CryptoUtils.createNewGuid()),
                            (this.scopes = o ? o.slice() : [t]),
                            (this.state = i),
                            (this.correlationId = a),
                            (this.xClientSku = 'MSAL.JS'),
                            (this.xClientVer = c.libraryVersion()),
                            (this.responseType = r),
                            (this.redirectUri = n);
                    }
                    t.ServerRequestParameters = o;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(2);
                    const o = r(6);
                    const i = r(1);
                    const a =
                        (Object.defineProperty(s.prototype, 'uid', {
                            get() {
                                return this._uid ? this._uid : '';
                            },
                            set(e) {
                                this._uid = e;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(s.prototype, 'utid', {
                            get() {
                                return this._utid ? this._utid : '';
                            },
                            set(e) {
                                this._utid = e;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        s);
                    function s(e) {
                        if (!e || i.StringUtils.isEmpty(e))
                            return (this.uid = ''), void (this.utid = '');
                        try {
                            const t = n.CryptoUtils.base64Decode(e);
                            const r = JSON.parse(t);
                            r &&
                                (r.hasOwnProperty('uid') && (this.uid = r.uid),
                                r.hasOwnProperty('utid') && (this.utid = r.utid));
                        } catch (e) {
                            throw o.ClientAuthError.createClientInfoDecodingError(e);
                        }
                    }
                    t.ClientInfo = a;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    function n(e) {
                        if (a.StringUtils.isEmpty(e))
                            throw o.ClientAuthError.createIdTokenNullOrEmptyError(e);
                        try {
                            (this.rawIdToken = e),
                                (this.claims = i.TokenUtils.extractIdToken(e)),
                                this.claims &&
                                    (this.claims.hasOwnProperty('iss') &&
                                        (this.issuer = this.claims.iss),
                                    this.claims.hasOwnProperty('oid') &&
                                        (this.objectId = this.claims.oid),
                                    this.claims.hasOwnProperty('sub') &&
                                        (this.subject = this.claims.sub),
                                    this.claims.hasOwnProperty('tid') &&
                                        (this.tenantId = this.claims.tid),
                                    this.claims.hasOwnProperty('ver') &&
                                        (this.version = this.claims.ver),
                                    this.claims.hasOwnProperty('preferred_username') &&
                                        (this.preferredName = this.claims.preferred_username),
                                    this.claims.hasOwnProperty('name') &&
                                        (this.name = this.claims.name),
                                    this.claims.hasOwnProperty('nonce') &&
                                        (this.nonce = this.claims.nonce),
                                    this.claims.hasOwnProperty('exp') &&
                                        (this.expiration = this.claims.exp),
                                    this.claims.hasOwnProperty('home_oid') &&
                                        (this.homeObjectId = this.claims.home_oid),
                                    this.claims.hasOwnProperty('sid') &&
                                        (this.sid = this.claims.sid),
                                    this.claims.hasOwnProperty('cloud_instance_host_name') &&
                                        (this.cloudInstance =
                                            this.claims.cloud_instance_host_name));
                        } catch (e) {
                            throw o.ClientAuthError.createIdTokenParsingError(e);
                        }
                    }
                    var o = r(6);
                    var i = r(14);
                    var a = r(1);
                    t.IdToken = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let s;
                    const n = r(0);
                    const c = r(3);
                    const u = r(31);
                    const o = r(32);
                    const l = r(6);
                    const i =
                        ((s = o.BrowserStorage),
                        n.__extends(a, s),
                        (a.prototype.migrateCacheEntries = function (r) {
                            const n = this;
                            const e = `${c.Constants.cachePrefix}.${c.PersistentCacheKeys.IDTOKEN}`;
                            const t = `${c.Constants.cachePrefix}.${c.PersistentCacheKeys.CLIENT_INFO}`;
                            const o = `${c.Constants.cachePrefix}.${c.ErrorCacheKeys.ERROR}`;
                            const i = `${c.Constants.cachePrefix}.${c.ErrorCacheKeys.ERROR_DESC}`;
                            const a = [
                                s.prototype.getItem.call(this, e),
                                s.prototype.getItem.call(this, t),
                                s.prototype.getItem.call(this, o),
                                s.prototype.getItem.call(this, i),
                            ];
                            [
                                c.PersistentCacheKeys.IDTOKEN,
                                c.PersistentCacheKeys.CLIENT_INFO,
                                c.ErrorCacheKeys.ERROR,
                                c.ErrorCacheKeys.ERROR_DESC,
                            ].forEach((e, t) => n.duplicateCacheEntry(e, a[t], r));
                        }),
                        (a.prototype.duplicateCacheEntry = function (e, t, r) {
                            t && this.setItem(e, t, r);
                        }),
                        (a.prototype.generateCacheKey = function (t, r) {
                            try {
                                return JSON.parse(t), t;
                            } catch (e) {
                                return t.indexOf(`${c.Constants.cachePrefix}`) === 0 ||
                                    t.indexOf(c.Constants.adalIdToken) === 0
                                    ? t
                                    : r
                                    ? `${c.Constants.cachePrefix}.${this.clientId}.${t}`
                                    : `${c.Constants.cachePrefix}.${t}`;
                            }
                        }),
                        (a.prototype.setItem = function (e, t, r, n) {
                            s.prototype.setItem.call(this, this.generateCacheKey(e, !0), t, r),
                                this.rollbackEnabled &&
                                    s.prototype.setItem.call(
                                        this,
                                        this.generateCacheKey(e, !1),
                                        t,
                                        r
                                    );
                        }),
                        (a.prototype.getItem = function (e, t) {
                            return s.prototype.getItem.call(this, this.generateCacheKey(e, !0), t);
                        }),
                        (a.prototype.removeItem = function (e) {
                            s.prototype.removeItem.call(this, this.generateCacheKey(e, !0)),
                                this.rollbackEnabled &&
                                    s.prototype.removeItem.call(this, this.generateCacheKey(e, !1));
                        }),
                        (a.prototype.resetCacheItems = function () {
                            let e;
                            const t = document.cookie.split('; ').reduce((e, t) => {
                                const r = t.split('=');
                                const n = r[0];
                                const o = r[1];
                                return (e[n] = o), e;
                            }, {});
                            for (e in t)
                                t.hasOwnProperty(e) &&
                                    e.indexOf(c.Constants.cachePrefix) !== -1 &&
                                    s.prototype.removeItem.call(this, e);
                        }),
                        (a.prototype.resetTempCacheItems = function (e) {
                            let t;
                            let r;
                            let n;
                            const o = document.cookie.split('; ').reduce((e, t) => {
                                const r = t.split('=');
                                const n = r[0];
                                const o = r[1];
                                return (e[n] = o), e;
                            }, {});
                            for (t in o)
                                (e && t.indexOf(e) === -1) ||
                                    (n =
                                        (r = t.split(c.Constants.resourceDelimiter)).length > 1
                                            ? r[r.length - 1]
                                            : null) !== e ||
                                    this.tokenRenewalInProgress(n) ||
                                    (this.removeItem(t),
                                    this.setItemCookie(t, '', -1),
                                    this.clearMsalCookie(e));
                            this.removeItem(c.TemporaryCacheKeys.INTERACTION_STATUS),
                                this.removeItem(c.TemporaryCacheKeys.REDIRECT_REQUEST);
                        }),
                        (a.prototype.setItemCookie = function (e, t, r) {
                            s.prototype.setItemCookie.call(
                                this,
                                this.generateCacheKey(e, !0),
                                t,
                                r
                            ),
                                this.rollbackEnabled &&
                                    s.prototype.setItemCookie.call(
                                        this,
                                        this.generateCacheKey(e, !1),
                                        t,
                                        r
                                    );
                        }),
                        (a.prototype.getItemCookie = function (e) {
                            return s.prototype.getItemCookie.call(
                                this,
                                this.generateCacheKey(e, !0)
                            );
                        }),
                        (a.prototype.getAllAccessTokens = function (i, a) {
                            const s = this;
                            const e = document.cookie.split('; ').reduce((e, t) => {
                                const r = t.split('=');
                                const n = r[0];
                                const o = r[1];
                                return (e[n] = o), e;
                            }, {});
                            return Object.keys(e).reduce((e, t) => {
                                if (t.match(i) && t.match(a) && t.match(c.Constants.scopes)) {
                                    const r = s.getItem(t);
                                    if (r)
                                        try {
                                            const n = JSON.parse(t);
                                            const o = new u.AccessTokenCacheItem(n, JSON.parse(r));
                                            return e.concat([o]);
                                        } catch (e) {
                                            throw l.ClientAuthError.createCacheParseError(t);
                                        }
                                }
                                return e;
                            }, []);
                        }),
                        (a.prototype.tokenRenewalInProgress = function (e) {
                            const t = this.getItem(`${c.TemporaryCacheKeys.RENEW_STATUS}|${e}`);
                            return !(!t || t !== c.Constants.inProgress);
                        }),
                        (a.prototype.clearMsalCookie = function (e) {
                            this.clearItemCookie(`${c.TemporaryCacheKeys.NONCE_IDTOKEN}|${e}`),
                                this.clearItemCookie(`${c.TemporaryCacheKeys.STATE_LOGIN}|${e}`),
                                this.clearItemCookie(`${c.TemporaryCacheKeys.LOGIN_REQUEST}|${e}`),
                                this.clearItemCookie(
                                    `${c.TemporaryCacheKeys.STATE_ACQ_TOKEN}|${e}`
                                );
                        }),
                        (a.generateAcquireTokenAccountKey = function (e, t) {
                            return `${c.TemporaryCacheKeys.ACQUIRE_TOKEN_ACCOUNT}${c.Constants.resourceDelimiter}${e}${c.Constants.resourceDelimiter}${t}`;
                        }),
                        (a.generateAuthorityKey = function (e) {
                            return `${c.TemporaryCacheKeys.AUTHORITY}${c.Constants.resourceDelimiter}${e}`;
                        }),
                        a);
                    function a(e, t, r) {
                        const n = s.call(this, t) || this;
                        return (
                            (n.clientId = e), (n.rollbackEnabled = !0), n.migrateCacheEntries(r), n
                        );
                    }
                    t.AuthCache = i;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    function n(e, t) {
                        (this.key = e), (this.value = t);
                    }
                    t.AccessTokenCacheItem = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(4);
                    const o = r(7);
                    const i =
                        ((a.prototype.setItem = function (e, t, r) {
                            this.setItemCookie(e, t);
                        }),
                        (a.prototype.getItem = function (e, t) {
                            return this.getItemCookie(e);
                        }),
                        (a.prototype.removeItem = function (e) {
                            return this.clearItemCookie(e);
                        }),
                        (a.prototype.clear = function () {
                            for (let e = document.cookie.split('; '), t = 0; t < e.length; t++)
                                for (let r = window.location.hostname.split('.'); r.length > 0; ) {
                                    const n = `${encodeURIComponent(
                                        e[t].split(';')[0].split('=')[0]
                                    )}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=${r.join(
                                        '.'
                                    )} ;path=`;
                                    const o = window.location.pathname.split('/');
                                    for (document.cookie = `${n}/`; o.length > 0; )
                                        (document.cookie = n + o.join('/')), o.pop();
                                    r.shift();
                                }
                        }),
                        (a.prototype.setItemCookie = function (e, t, r) {
                            let n = `${e}=${t};path=/;secure=true;`;
                            r && (n += `expires=${this.getCookieExpirationTime(r)};`),
                                (document.cookie = n);
                        }),
                        (a.prototype.getItemCookie = function (e) {
                            for (
                                let t = `${e}=`, r = document.cookie.split(';'), n = 0;
                                n < r.length;
                                n++
                            ) {
                                for (var o = r[n]; o.charAt(0) === ' '; ) o = o.substring(1);
                                if (o.indexOf(t) === 0) return o.substring(t.length, o.length);
                            }
                            return '';
                        }),
                        (a.prototype.clearItemCookie = function (e) {
                            this.setItemCookie(e, '', -1);
                        }),
                        (a.prototype.getCookieExpirationTime = function (e) {
                            const t = new Date();
                            return new Date(t.getTime() + 24 * e * 60 * 60 * 1e3).toUTCString();
                        }),
                        a);
                    function a(e) {
                        if (!window)
                            throw o.AuthError.createNoWindowObjectError(
                                'Browser storage class could not find window object'
                            );
                        if (!(void 0 !== window[e] && window[e] != null))
                            throw n.ClientConfigurationError.createStorageNotSupportedError(e);
                        this.cacheLocation = e;
                    }
                    t.BrowserStorage = i;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const c = r(6);
                    const u = r(5);
                    const o = r(3);
                    const n =
                        ((l.isInIframe = function () {
                            return window.parent !== window;
                        }),
                        (l.isInPopup = function () {
                            return !(!window.opener || window.opener === window);
                        }),
                        (l.monitorWindowForHash = function (a, e, s) {
                            return new Promise((t, r) => {
                                const n = e / l.POLLING_INTERVAL_MS;
                                let o = 0;
                                var i = setInterval(() => {
                                    if (a.closed)
                                        return (
                                            clearInterval(i),
                                            void r(c.ClientAuthError.createUserCancelledError())
                                        );
                                    let e;
                                    try {
                                        e = a.location.href;
                                    } catch (e) {}
                                    e &&
                                        e !== 'about:blank' &&
                                        (o++,
                                        u.UrlUtils.urlContainsHash(e)
                                            ? (clearInterval(i), t(a.location.hash))
                                            : n < o &&
                                              (clearInterval(i),
                                              r(
                                                  c.ClientAuthError.createTokenRenewalTimeoutError(
                                                      s
                                                  )
                                              )));
                                }, l.POLLING_INTERVAL_MS);
                            });
                        }),
                        (l.loadFrame = function (n, o, e, i) {
                            return (
                                i.info(`LoadFrame: ${o}`),
                                new Promise((t, r) => {
                                    setTimeout(() => {
                                        const e = l.addHiddenIFrame(o, i);
                                        e
                                            ? ((e.src !== '' && e.src !== 'about:blank') ||
                                                  ((e.src = n),
                                                  i.infoPii(
                                                      `Frame Name : ${o} Navigated to: ${n}`
                                                  )),
                                              t(e))
                                            : r(`Unable to load iframe with name: ${o}`);
                                    }, e);
                                })
                            );
                        }),
                        (l.addHiddenIFrame = function (e, t) {
                            if (void 0 === e) return null;
                            t.info(`Add msal frame to document:${e}`);
                            let r;
                            let n = document.getElementById(e);
                            return (
                                n ||
                                    (document.createElement &&
                                    document.documentElement &&
                                    window.navigator.userAgent.indexOf('MSIE 5.0') === -1
                                        ? ((r = document.createElement('iframe')).setAttribute(
                                              'id',
                                              e
                                          ),
                                          (r.style.visibility = 'hidden'),
                                          (r.style.position = 'absolute'),
                                          (r.style.width = r.style.height = '0'),
                                          (r.style.border = '0'),
                                          r.setAttribute(
                                              'sandbox',
                                              'allow-scripts allow-same-origin allow-forms'
                                          ),
                                          (n = document
                                              .getElementsByTagName('body')[0]
                                              .appendChild(r)))
                                        : document.body &&
                                          document.body.insertAdjacentHTML &&
                                          document.body.insertAdjacentHTML(
                                              'beforeend',
                                              `<iframe name='${e}' id='${e}' style='display:none'></iframe>`
                                          ),
                                    window.frames && window.frames[e] && (n = window.frames[e])),
                                n
                            );
                        }),
                        (l.removeHiddenIframe = function (e) {
                            document.body !== e.parentNode && document.body.removeChild(e);
                        }),
                        (l.getIframeWithHash = function (t) {
                            const r = document.getElementsByTagName('iframe');
                            return Array.apply(null, Array(r.length))
                                .map((e, t) => r.item(t))
                                .filter((e) => {
                                    try {
                                        return e.contentWindow.location.hash === t;
                                    } catch (e) {
                                        return !1;
                                    }
                                })[0];
                        }),
                        (l.getPopups = function () {
                            return (
                                window.openedWindows || (window.openedWindows = []),
                                window.openedWindows
                            );
                        }),
                        (l.getPopUpWithHash = function (t) {
                            return l.getPopups().filter((e) => {
                                try {
                                    return e.location.hash === t;
                                } catch (e) {
                                    return !1;
                                }
                            })[0];
                        }),
                        (l.trackPopup = function (e) {
                            l.getPopups().push(e);
                        }),
                        (l.closePopups = function () {
                            l.getPopups().forEach((e) => e.close());
                        }),
                        (l.blockReloadInHiddenIframes = function () {
                            if (u.UrlUtils.urlContainsHash(window.location.hash) && l.isInIframe())
                                throw c.ClientAuthError.createBlockTokenRequestsInHiddenIframeError();
                        }),
                        (l.checkIfBackButtonIsPressed = function (e) {
                            let t;
                            let r;
                            const n = e.getItem(o.TemporaryCacheKeys.REDIRECT_REQUEST);
                            n &&
                                !u.UrlUtils.urlContainsHash(window.location.hash) &&
                                ((r =
                                    (t = n.split(o.Constants.resourceDelimiter)).length > 1
                                        ? t[t.length - 1]
                                        : null),
                                e.resetTempCacheItems(r));
                        }),
                        (l.POLLING_INTERVAL_MS = 50),
                        l);
                    function l() {}
                    t.WindowUtils = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n =
                        ((o.parseExpiresIn = function (e) {
                            return (e = e || '3599'), parseInt(e, 10);
                        }),
                        (o.now = function () {
                            return Math.round(new Date().getTime() / 1e3);
                        }),
                        o);
                    function o() {}
                    t.TimeUtils = n;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const u = r(0);
                    const l = r(3);
                    const h = r(4);
                    const d = r(10);
                    const n = r(1);
                    const o = r(2);
                    const i =
                        ((a.validateRequest = function (e, t, r, n, o) {
                            if (!t && !e)
                                throw h.ClientConfigurationError.createEmptyRequestError();
                            if (n == l.Constants.interactionTypeRedirect && !o)
                                throw h.ClientConfigurationError.createRedirectCallbacksNotSetError();
                            let i;
                            let a;
                            e &&
                                ((i = t
                                    ? d.ScopeSet.appendScopes(e.scopes, e.extraScopesToConsent)
                                    : e.scopes),
                                d.ScopeSet.validateInputScope(i, !t, r),
                                this.validatePromptParameter(e.prompt),
                                (a = this.validateEQParameters(
                                    e.extraQueryParameters,
                                    e.claimsRequest
                                )),
                                this.validateClaimsRequest(e.claimsRequest));
                            const s = this.validateAndGenerateState(e && e.state);
                            const c = this.validateAndGenerateCorrelationId(e && e.correlationId);
                            return u.__assign({}, e, {
                                extraQueryParameters: a,
                                scopes: i,
                                state: s,
                                correlationId: c,
                            });
                        }),
                        (a.validatePromptParameter = function (e) {
                            if (
                                e &&
                                [
                                    l.PromptState.LOGIN,
                                    l.PromptState.SELECT_ACCOUNT,
                                    l.PromptState.CONSENT,
                                    l.PromptState.NONE,
                                ].indexOf(e) < 0
                            )
                                throw h.ClientConfigurationError.createInvalidPromptError(e);
                        }),
                        (a.validateEQParameters = function (e, t) {
                            const r = u.__assign({}, e);
                            return r
                                ? (t && delete r[l.Constants.claims],
                                  l.BlacklistedEQParams.forEach((e) => {
                                      r[e] && delete r[e];
                                  }),
                                  r)
                                : null;
                        }),
                        (a.validateClaimsRequest = function (e) {
                            if (e)
                                try {
                                    JSON.parse(e);
                                } catch (e) {
                                    throw h.ClientConfigurationError.createClaimsRequestParsingError(
                                        e
                                    );
                                }
                        }),
                        (a.validateAndGenerateState = function (e) {
                            return n.StringUtils.isEmpty(e)
                                ? o.CryptoUtils.createNewGuid()
                                : `${o.CryptoUtils.createNewGuid()}|${e}`;
                        }),
                        (a.validateAndGenerateCorrelationId = function (e) {
                            if (e && !o.CryptoUtils.isGuid(e))
                                throw h.ClientConfigurationError.createInvalidCorrelationIdError();
                            return o.CryptoUtils.isGuid(e) ? e : o.CryptoUtils.createNewGuid();
                        }),
                        a);
                    function a() {}
                    t.RequestUtils = i;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(0);
                    const o =
                        ((i.setResponseIdToken = function (e, t) {
                            if (!e) return null;
                            if (!t) return e;
                            const r = Number(t.expiration);
                            return (
                                r && !e.expiresOn && (e.expiresOn = new Date(1e3 * r)),
                                n.__assign({}, e, {
                                    idToken: t,
                                    idTokenClaims: t.claims,
                                    uniqueId: t.objectId || t.subject,
                                    tenantId: t.tenantId,
                                })
                            );
                        }),
                        i);
                    function i() {}
                    t.ResponseUtils = o;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(16);
                    const o = r(18);
                    const i = r(8);
                    const a = r(4);
                    const s = r(5);
                    const c = r(1);
                    const u =
                        ((l.DetectAuthorityFromUrl = function (e) {
                            switch (
                                ((e = s.UrlUtils.CanonicalizeUri(e)),
                                s.UrlUtils.GetUrlComponents(e).PathSegments[0])
                            ) {
                                case 'tfp':
                                    return i.AuthorityType.B2C;
                                default:
                                    return i.AuthorityType.Aad;
                            }
                        }),
                        (l.CreateInstance = function (e, t) {
                            if (c.StringUtils.isEmpty(e)) return null;
                            switch (l.DetectAuthorityFromUrl(e)) {
                                case i.AuthorityType.B2C:
                                    return new o.B2cAuthority(e, t);
                                case i.AuthorityType.Aad:
                                    return new n.AadAuthority(e, t);
                                default:
                                    throw a.ClientConfigurationErrorMessage.invalidAuthorityType;
                            }
                        }),
                        l);
                    function l() {}
                    t.AuthorityFactory = u;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    function n(e) {
                        return `${e.telemetryCorrelationId}-${e.eventId}-${e.eventName}`;
                    }
                    const s = r(0).__importDefault(r(39));
                    const o =
                        ((i.prototype.startEvent = function (e) {
                            let t;
                            this.telemetryEmitter && ((t = n(e)), (this.inProgressEvents[t] = e));
                        }),
                        (i.prototype.stopEvent = function (e) {
                            let t;
                            const r = n(e);
                            this.telemetryEmitter &&
                                this.inProgressEvents[r] &&
                                (e.stop(),
                                this.incrementEventCount(e),
                                (t = this.completedEvents[e.telemetryCorrelationId]),
                                (this.completedEvents[e.telemetryCorrelationId] = (t || []).concat([
                                    e,
                                ])),
                                delete this.inProgressEvents[r]);
                        }),
                        (i.prototype.flush = function (e) {
                            let t;
                            let r;
                            let n;
                            let o;
                            let i;
                            const a = this;
                            this.telemetryEmitter &&
                                this.completedEvents[e] &&
                                ((t = this.getOrphanedEvents(e)).forEach((e) =>
                                    a.incrementEventCount(e)
                                ),
                                (r = this.completedEvents[e].concat(t)),
                                delete this.completedEvents[e],
                                (n = this.eventCountByCorrelationId[e]),
                                delete this.eventCountByCorrelationId[e],
                                r &&
                                    r.length &&
                                    ((o = new s.default(
                                        this.telemetryPlatform,
                                        e,
                                        this.clientId,
                                        n
                                    )),
                                    (i = r.concat([o])),
                                    this.telemetryEmitter(i.map((e) => e.get()))));
                        }),
                        (i.prototype.incrementEventCount = function (e) {
                            let t;
                            const r = e.eventName;
                            const n = this.eventCountByCorrelationId[e.telemetryCorrelationId];
                            n
                                ? (n[r] = n[r] ? n[r] + 1 : 1)
                                : (this.eventCountByCorrelationId[e.telemetryCorrelationId] =
                                      (((t = {})[r] = 1), t));
                        }),
                        (i.prototype.getOrphanedEvents = function (n) {
                            const o = this;
                            return Object.keys(this.inProgressEvents).reduce((e, t) => {
                                if (t.indexOf(n) === -1) return e;
                                const r = o.inProgressEvents[t];
                                return delete o.inProgressEvents[t], e.concat([r]);
                            }, []);
                        }),
                        i);
                    function i(e, t) {
                        (this.completedEvents = {}),
                            (this.inProgressEvents = {}),
                            (this.eventCountByCorrelationId = {}),
                            (this.onlySendFailureTelemetry = !1),
                            (this.telemetryPlatform = e.platform),
                            (this.clientId = e.clientId),
                            (this.onlySendFailureTelemetry = e.onlySendFailureTelemetry),
                            (this.telemetryEmitter = t);
                    }
                    t.default = o;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    let i;
                    const n = r(0);
                    const a = r(9);
                    const o = n.__importDefault(r(40));
                    const s = r(22);
                    const c =
                        ((i = o.default),
                        n.__extends(u, i),
                        (u.prototype.getEventCount = function (e, t) {
                            return t[e] ? t[e] : 0;
                        }),
                        u);
                    function u(e, t, r, n) {
                        const o =
                            i.call(this, s.prependEventNamePrefix('default_event'), t) || this;
                        return (
                            (o.event[s.prependEventNamePrefix('client_id')] = r),
                            (o.event[s.prependEventNamePrefix('sdk_plaform')] = e.sdk),
                            (o.event[s.prependEventNamePrefix('sdk_version')] = e.sdkVersion),
                            (o.event[s.prependEventNamePrefix('application_name')] =
                                e.applicationName),
                            (o.event[s.prependEventNamePrefix('application_version')] =
                                e.applicationVersion),
                            (o.event[
                                `${a.TELEMETRY_BLOB_EVENT_NAMES.UiEventCountTelemetryBatchKey}`
                            ] = o.getEventCount(s.prependEventNamePrefix('ui_event'), n)),
                            (o.event[
                                `${a.TELEMETRY_BLOB_EVENT_NAMES.HttpEventCountTelemetryBatchKey}`
                            ] = o.getEventCount(s.prependEventNamePrefix('http_event'), n)),
                            (o.event[`${a.TELEMETRY_BLOB_EVENT_NAMES.CacheEventCountConstStrKey}`] =
                                o.getEventCount(s.prependEventNamePrefix('cache_event'), n)),
                            o
                        );
                    }
                    t.default = c;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(0);
                    const o = r(9);
                    const i = r(9);
                    const a = r(22);
                    const s = r(2);
                    const c =
                        ((u.prototype.setElapsedTime = function (e) {
                            this.event[a.prependEventNamePrefix(i.ELAPSED_TIME_KEY)] = e;
                        }),
                        (u.prototype.stop = function () {
                            this.setElapsedTime(Date.now() - this.startTimestamp);
                        }),
                        Object.defineProperty(u.prototype, 'telemetryCorrelationId', {
                            get() {
                                return this.event[
                                    `${o.TELEMETRY_BLOB_EVENT_NAMES.MsalCorrelationIdConstStrKey}`
                                ];
                            },
                            set(e) {
                                this.event[
                                    `${o.TELEMETRY_BLOB_EVENT_NAMES.MsalCorrelationIdConstStrKey}`
                                ] = e;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        Object.defineProperty(u.prototype, 'eventName', {
                            get() {
                                return this.event[a.prependEventNamePrefix(i.EVENT_NAME_KEY)];
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (u.prototype.get = function () {
                            return n.__assign({}, this.event, { eventId: this.eventId });
                        }),
                        u);
                    function u(e, t) {
                        let r;
                        (this.startTimestamp = Date.now()),
                            (this.eventId = s.CryptoUtils.createNewGuid()),
                            (this.event =
                                (((r = {})[a.prependEventNamePrefix(i.EVENT_NAME_KEY)] = e),
                                (r[a.prependEventNamePrefix(i.START_TIME_KEY)] =
                                    this.startTimestamp),
                                (r[a.prependEventNamePrefix(i.ELAPSED_TIME_KEY)] = -1),
                                (r[`${o.TELEMETRY_BLOB_EVENT_NAMES.MsalCorrelationIdConstStrKey}`] =
                                    t),
                                r));
                    }
                    t.default = c;
                },
                function (e, t, r) {
                    Object.defineProperty(t, '__esModule', { value: !0 });
                    const n = r(4);
                    t.validateClaimsRequest = function (e) {
                        if (e.claimsRequest)
                            try {
                                JSON.parse(e.claimsRequest);
                            } catch (e) {
                                throw n.ClientConfigurationError.createClaimsRequestParsingError(e);
                            }
                    };
                },
            ]),
        (o.c = n),
        (o.d = function (e, t, r) {
            o.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
        }),
        (o.r = function (e) {
            typeof Symbol !== 'undefined' &&
                Symbol.toStringTag &&
                Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
                Object.defineProperty(e, '__esModule', { value: !0 });
        }),
        (o.t = function (t, e) {
            if ((1 & e && (t = o(t)), 8 & e)) return t;
            if (4 & e && typeof t === 'object' && t && t.__esModule) return t;
            const r = Object.create(null);
            if (
                (o.r(r),
                Object.defineProperty(r, 'default', { enumerable: !0, value: t }),
                2 & e && typeof t !== 'string')
            )
                for (const n in t) o.d(r, n, ((e) => t[e]).bind(null, n));
            return r;
        }),
        (o.n = function (e) {
            const t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return o.d(t, 'a', t), t;
        }),
        (o.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (o.p = ''),
        o((o.s = 23))
    );
    function o(e) {
        if (n[e]) return n[e].exports;
        const t = (n[e] = { i: e, l: !1, exports: {} });
        return r[e].call(t.exports, t, t.exports, o), (t.l = !0), t.exports;
    }
    let r;
    let n;
});
